export const courseDiscountTypes = {
  AVOIDANCE: 'AVOIDANCE',
  DEFENSIVE: 'DEFENSIVE',
  INEXPERIENCED: 'INEXPERIENCED',
  PREVENTION: 'PREVENTION',
  SENIOR: 'SENIOR',
  MILITARY_DEFENSIVE: 'MILITARY_DEFENSIVE',
  NATIONAL_GUARD: 'NATIONAL_GUARD'
};

export const bixStates = {
  AR: true,
  AZ: true,
  DC: true,
  FL: true,
  GA: true,
  IA: true,
  IL: true,
  IN: true,
  KY: true,
  LA: true,
  MD: true,
  MI: true,
  MO: true,
  MS: true,
  MT: true,
  ND: true,
  NE: true,
  NM: true,
  OH: true,
  OK: true,
  OR: true,
  PA: true,
  TX: true,
  UT: true,
  WI: true,
  WV: true
};

export const originalGSNICStates = ['AZ', 'IL', 'OH', 'MO', 'TX'];

// Turn on FL when adding 'FL' to branchLiveStates if we don't want to get online quotes.
export const preventQuoteOnlineStates = { FL: false };

export const branchLiveStates = [
  'AR',
  'AZ',
  'DC',
  'GA',
  'IA',
  'IL',
  'IN',
  'KY',
  'LA',
  'MD',
  'MI',
  'MO',
  'MS',
  'MT',
  'ND',
  'NE',
  'NM',
  'OH',
  'OK',
  'OR',
  'PA',
  'TX',
  'UT',
  'WI',
  'WV'
];

// Policy types that require checking states in locations instead of userInput.state
export const policyTypesToCheckStateInLocations = ['F', 'Z', 'Y']; // F = farm, Z = home, Y = rental

export interface StatePolicyType {
  state: string;
  policyTypes: string[];
}

export class ReopeningStatesArray extends Array<StatePolicyType> {
  isStateReopenedForPolicyType(state: string, policyType: string): boolean {
    const reopenedState = this.find((entry) => entry.state === state);
    return reopenedState ? reopenedState.policyTypes.includes(policyType) : false;
  }

  // To keep backwards compatibility with the previous reopening states structure
  // I've overwritten this method to support both string or object includes
  override includes(searchElement: any, fromIndex?: number): boolean {
    if (typeof searchElement === 'string') {
      // If searchElement is a string, treat it as a state and check for its existence
      return this.some((entry) => entry.state === searchElement);
    }
    // Default includes behavior for StatePolicyType objects
    return super.includes(searchElement, fromIndex);
  }
}

export const reopeningStates = new ReopeningStatesArray(
  { state: 'AR', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'AZ', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'DC', policyTypes: ['A'] },
  { state: 'GA', policyTypes: ['A', 'H'] },
  { state: 'IA', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'IL', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'IN', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'KY', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'MO', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'MT', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'ND', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'NE', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'NM', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'OH', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'OK', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'OR', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'TX', policyTypes: ['A'] },
  { state: 'UT', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'WI', policyTypes: ['H', 'A', 'C', 'R'] },
  { state: 'WV', policyTypes: ['A'] }
);

export const branchPlusCarriers = ['loggerhead', 'orchid', 'annex', 'delos'];
export const branchPlusPolicyTypes = [
  'home',
  'renters',
  'condo',
  'personal umbrella',
  'home and personal umbrella',
  'renters and personal Umbrella',
  'condo and personal umbrella'
];
export const statesEligibleForBranchPlusMPD = {
  FL: { A: true }
};

export const noConnectedHomeProviderSpecialOfferByState = {
  MD: ['SimpliSafe']
};
export const connectedHomeMonitoredNCustomExperienceStates = ['IL'];
export const noTrailerCoverageStates = ['MA', 'NJ', 'NY', 'VA'];

export const shortRateFeeStates = {};

export const checkCarRecallsStates = Object.keys(bixStates).filter(
  (state: string) => bixStates[state as keyof typeof bixStates]
);

/**
 * Valid Zip Codes can be represented as either a single value, or "tuples" containing the min & max values of a range.
 * Values are inclusive.
 */
export const validZipCodeRanges: { [index: string]: [[number, number]] } = {
  AL: [[35000, 36999]],
  AR: [[71601, 72999]],
  AZ: [[85001, 86556]],
  CO: [[80001, 82000]],
  DC: [[20001, 20899]],
  FL: [[32000, 34999]],
  GA: [[30000, 39999]],
  IA: [[50001, 52999]],
  ID: [[83200, 84000]],
  IL: [[60001, 62999]],
  IN: [[46001, 47997]],
  KS: [[66000, 69999]],
  KY: [[40003, 42999]],
  LA: [[70000, 71999]],
  MA: [[1001, 5599]],
  MD: [[20331, 21999]],
  ME: [[3901, 4992]],
  MI: [[48001, 49999]],
  MO: [[63001, 65899]],
  MS: [[38601, 39999]],
  MT: [[59001, 59999]],
  ND: [[58000, 58999]],
  NE: [[68001, 69999]],
  NH: [[3000, 3900]],
  NM: [[87001, 89999]],
  OH: [[43001, 45999]],
  OK: [[73001, 74999]],
  OR: [[97000, 97999]],
  PA: [[15001, 19999]],
  SC: [[29001, 29999]],
  SD: [[57001, 57999]],
  TN: [[37000, 39999]],
  TX: [[73301, 88589]],
  UT: [[84000, 84999]],
  VA: [[20000, 24999]],
  VT: [[5000, 5999]],
  WI: [[53001, 55000]],
  WV: [[24701, 26999]],
  WY: [[82001, 83199]]
};

export const umUimCoverageArray = {
  AK: ['UM', 'UIM'],
  AL: ['UM'],
  AR: ['UMBI', 'UIM'],
  AZ: ['UM_UIM'],
  CO: ['UM_UIM'],
  DC: ['UMBI', 'UIMBI', 'UIM', 'UM'],
  FL: ['UM'],
  GA: ['UM'],
  IA: ['UM', 'UIM'],
  ID: ['UM', 'UIM'],
  IL: ['UMUIM', 'UM_UIM'],
  IN: ['UM_UIM'],
  KS: ['UMUIM'],
  KY: ['UM', 'UIM'],
  LA: ['UMBI'],
  MA: ['UM', 'UIM'],
  MD: ['UM', 'EUIM'],
  ME: ['UMUIM'],
  MO: ['UM', 'UIM'],
  MI: ['UMUIM'],
  MS: ['UM', 'UIM'],
  MT: ['UM', 'UIM'],
  ND: ['UM', 'UIM'],
  NE: ['UM', 'UIM'],
  NH: ['UM', 'UIM'],
  NM: ['UMUIM'],
  OH: ['UM_UIM'],
  OK: ['UM'],
  OR: ['UM'],
  PA: ['UM', 'UIM'],
  SC: ['UM', 'UIM'],
  SD: ['UM', 'UIM'],
  TN: ['UM'],
  TX: ['UMUIMBI', 'UMUIMPD'],
  UT: ['UM', 'UIM'],
  VA: ['UMUIM'],
  VT: ['UM', 'UIM'],
  WI: ['UM', 'UIM'],
  WV: ['UMBI', 'UIMBI'],
  WY: ['UM']
};

export const disableExcludeDriverStates = {
  AL: true,
  AR: true,
  AZ: true,
  CO: true,
  DC: true,
  GA: true,
  IA: true,
  ID: true,
  IL: true,
  IN: true,
  KS: true,
  KY: true,
  LA: true,
  MA: true,
  ME: true,
  MI: true,
  MO: true,
  MS: true,
  MT: true,
  ND: true,
  NH: true,
  NE: true,
  NM: true,
  OH: true,
  OK: true,
  OR: true,
  PA: true,
  SC: true,
  SD: true,
  TN: true,
  TX: true,
  UT: true,
  VA: true,
  VT: true,
  WI: true,
  WV: true,
  WY: true
};

export const noUmbrellaStates = { KS: true, MA: true, WV: true };
export const umbrellaStartDateStates = {
  GA: '2023-06-01',
  MT: '2022-11-20'
};

// States that still use only the violation-code umbrella check and skip the driving-history criteria
// from #24259 (AAF for drivers <= 21 / >= 70 in the last 3 years, AAF with >= 50K BI paid in the last
// 5 years). The list shrinks as product opts states in: OR (#27055), OK (#27249), KY + MO (#35432).
export const legacyUmbrellaCriteriaStates = ['MI', 'MD', 'PA', 'TX'];

export const verifiedAnnualMilesNoticeStates = ['PA'];
export const verifiedAnnualMilesProofThreshold = 10000;
export const verifiedAnnualMilesMax = 100000;

export const isPlausibleReportedAnnualMiles = (miles: unknown): boolean =>
  Number.isInteger(miles) && (miles as number) > 0 && (miles as number) <= verifiedAnnualMilesMax;

// Reported annual miles go live on this date (#34636); until then every site behaves as if the field did not exist.
export const annualMilesRolloutDate = '2026-11-21';

/** `today` is a yyyy-MM-dd business date, e.g. `getTodayStr(state)` from `@ourbranch/date-fns-helpers`. */
export const isApplicantAnnualMilesEnabled = (state: string | null | undefined, today: string): boolean =>
  verifiedAnnualMilesNoticeStates.includes(state as string) && today >= annualMilesRolloutDate;

export const myCommunityDiscountStateCaps = {
  AR: 0,
  AZ: 25,
  IA: 0,
  ID: 0,
  IL: 0,
  IN: 0,
  KY: 0,
  LA: 0,
  MO: 50,
  MS: 0,
  MT: 0,
  NH: 0,
  NM: 0,
  OH: 0,
  SD: 0,
  TX: 0,
  VT: 0,
  WV: 0
};

export const myCommunityDiscountVerbalReferralStates = ['IA', 'NM', 'NE', 'OH'];

export const alabamaLogicInstallmentFeeStates = {
  AL: true
};

export const fixedHomeInstallmentFeeStates = {
  LA: true
};

export const courseDiscountTypeByStates = {
  AL: courseDiscountTypes.SENIOR,
  AR: courseDiscountTypes.SENIOR,
  AZ: false,
  CO: courseDiscountTypes.SENIOR,
  DC: courseDiscountTypes.SENIOR,
  FL: courseDiscountTypes.DEFENSIVE,
  GA: false,
  IA: false,
  ID: courseDiscountTypes.SENIOR,
  IL: courseDiscountTypes.SENIOR,
  IN: false,
  KS: courseDiscountTypes.AVOIDANCE,
  KY: courseDiscountTypes.SENIOR,
  LA: false,
  MA: courseDiscountTypes.INEXPERIENCED,
  ME: courseDiscountTypes.SENIOR,
  MI: false,
  MO: false,
  MS: courseDiscountTypes.SENIOR,
  MT: courseDiscountTypes.SENIOR,
  ND: courseDiscountTypes.DEFENSIVE,
  NH: false,
  NE: false,
  NM: courseDiscountTypes.SENIOR,
  OH: courseDiscountTypes.SENIOR,
  OK: courseDiscountTypes.DEFENSIVE,
  OR: courseDiscountTypes.SENIOR,
  PA: courseDiscountTypes.DEFENSIVE,
  SC: courseDiscountTypes.DEFENSIVE,
  SD: courseDiscountTypes.SENIOR,
  TN: courseDiscountTypes.SENIOR,
  TX: false,
  UT: courseDiscountTypes.SENIOR,
  VT: false,
  WI: false,
  WV: courseDiscountTypes.SENIOR,
  WY: courseDiscountTypes.SENIOR
};

export const additionalDriverDiscountsTypesByStates = {
  // this allows for only one additional discount, will need refactor if we end up with states where driver can have 3+ discounts offered
  KY: {
    condition: 'IS_ACTIVE_DUTY',
    discountType: courseDiscountTypes.MILITARY_DEFENSIVE
  },
  MT: {
    condition: 'IS_ACTIVE_DUTY_NG',
    discountType: courseDiscountTypes.NATIONAL_GUARD
  }
};

export const stateSpecificToolTips = {
  KY: 'discountCourseKY',
  MA: 'inexperiencedCourseMA'
};

export const seniorDiscountByAgeOnlyStates = {
  FL: 55,
  KY: 55,
  MI: 65
};

export const lapsedLicenseMonthsStates = {
  MA: 12
};

export const courseDiscountsAges = {
  AL: 55,
  AR: 55,
  CO: 55,
  DC: 50,
  FL: 55,
  ID: 55,
  IL: 55,
  KS: 1,
  KY: 55,
  MA: 7, // To be used as: age - ageFirstLicensed < courseDiscountsAges[state]
  ME: 55,
  MS: 55,
  MT: 55,
  ND: 1,
  NM: 55,
  OH: 60,
  OK: 1,
  OR: 55,
  PA: 55,
  SC: 1,
  SD: 55,
  TN: 55,
  UT: 55,
  VA: 60,
  WV: 55,
  WY: 55
};

export const zendeskInfoByStateWithKeys = {
  KY: {
    IS_ACTIVE_DUTY:
      'has taken a voluntary accident prevention course provided by the Armed Forces in the last 5 years.',
    SENIOR:
      'has taken an Accident Prevention Course approved by the Transportation Cabinet of Kentucky within the last 5 years.'
  },
  MA: {
    [courseDiscountTypes.INEXPERIENCED]: `has taken a Driver Training Course in the last ${courseDiscountsAges.MA} years`
  },
  MT: {
    IS_ACTIVE_DUTY_NG: 'has taken a voluntary, state-approved defensive driving course.',
    SENIOR: 'has taken a state-approved defensive driving course.'
  }
};

export const directAffinityCodes = ['KST1', 'SMAFIN1', 'QWZ1'];
export const partnerMonolineRejectionAffinityCodes = ['ORL1', 'ORL2', 'ORL3', 'ORL4', 'ORLE'];

export const offerMergingNotAllowedAffinityCodes = [];
export const skipPriorBIMonolineRejectionAffinityCodes = ['CO0035', 'LA0008'];

export const hurricaneDeductibleStates = {
  AZ: false,
  CO: false,
  IL: false,
  IN: false,
  KS: false,
  LA: true,
  MA: true,
  MO: false,
  OH: false,
  TX: false
};

export const sR22States = { NH: true };

export const mandatoryWindHailDeductible = {};
export const limitedBranchWindhailCoverage = {
  AL: { residualMarket: 'AIUA', link: 'https://aiua.org/' },
  GA: { residualMarket: 'GUA', link: 'https://www.georgiaunderwriting.com/' }
};

export const homeownersRights = {
  AL: 'https://www.aldoi.gov/PDF/Consumers/HomeownersBillofRightsAct.pdf'
};

// Vehicle MSRP Configuration by State
// Michigan keeps old limit of $90k, all other states use new limit of $125k
export const autoMaximumCarMSRP = {
  default: 125000, // Countrywide default
  MI: 90000 // Michigan keeps old limit
};

// Helper function to get MSRP limit by state
export const getMaximumCarMSRP = (state: string): number => {
  return autoMaximumCarMSRP[state as keyof typeof autoMaximumCarMSRP] ?? autoMaximumCarMSRP.default;
};

// Driver-to-Vehicle Ratio Configuration by State
// Michigan keeps old ratio of 2 (1:2), all other states use new ratio of 2.5 (1:2.5)
export const autoDriverToVehicleRatio = {
  default: 2.5, // Countrywide default
  MI: 2 // Michigan keeps old ratio
};

// Helper function to get ratio by state
export const getDriverToVehicleRatio = (state: string): number => {
  return autoDriverToVehicleRatio[state as keyof typeof autoDriverToVehicleRatio] ?? autoDriverToVehicleRatio.default;
};

// Single Driver Maximum Vehicles Configuration
// Countrywide: single drivers can have up to 3 vehicles
// Michigan: single drivers can have up to 2 vehicles (follows 1:2 ratio)
export const autoSingleDriverMaxVehicles = {
  default: 3, // Countrywide default - single drivers can have up to 3 vehicles
  MI: 2 // Michigan keeps old limit (follows 1:2 ratio)
};

// Helper function to get single driver max vehicles by state
export const getSingleDriverMaxVehicles = (state: string): number => {
  return (
    autoSingleDriverMaxVehicles[state as keyof typeof autoSingleDriverMaxVehicles] ??
    autoSingleDriverMaxVehicles.default
  );
};

// Keep old constant for backward compatibility (can be deprecated later)
export const maximumCarMSRP = 90000;

/** States that, when they have a minimum % deductible, only allow % deductibles */
export const percentageWindHailDeductible = { MD: true };

// note that we include the policy-level UMPD states here!
export const umpdWithCollisionStates = [
  'AR',
  'DC',
  'GA',
  'ID',
  'IL',
  'IN',
  'MD',
  'MS',
  'OR',
  'SC',
  'TN',
  'TX',
  'VA',
  'VT',
  'WV',
  'WY'
];
export const noUDRsAllowedStates = ['IN', 'MD'];
export const allowBindUDRStates = ['KY', 'ME', 'MD', 'MI', 'NH'];

export const limitedCollisionStates = { MA: true };

export const minimumDeductibleCollision = 500;
export const minimumDeductibleComprehensive = 500;

export const UMBIEqualsBIStates = {
  NH: true
};

export const UIMBIEqualsUMBIUnlessRejectStates = {
  AR: true,
  MA: true,
  MT: true
};

export const combinedUMUIM = {
  AL: true,
  AR: false,
  AZ: false,
  CO: true,
  DC: false,
  FL: true,
  GA: true,
  IA: true,
  ID: false,
  IL: true,
  IN: true,
  KS: true,
  LA: true,
  MA: false,
  MD: true,
  ME: true,
  MI: true,
  MO: false,
  MS: true,
  MT: false,
  ND: true,
  NE: true,
  NH: true,
  NM: true,
  OH: true,
  OK: true,
  OR: true,
  PA: false,
  SC: false,
  SD: true,
  TN: true,
  TX: true,
  UT: false,
  VA: true,
  VT: true,
  WI: false,
  WV: false,
  WY: true
};

export const policyLevelUMPDStates = {
  AR: true,
  DC: true,
  GA: true,
  IN: true,
  MD: true,
  MS: true,
  SC: true,
  TN: true,
  TX: true,
  VA: true,
  VT: true,
  WV: true,
  WY: true
};
export const policyLevelUMPDInUMSelectionStates = {
  DC: true,
  SC: true,
  WV: true
};

export const allow50100UMBIon2550BIStates = {
  VT: true
};

export const UMPDOnlyWithUMBIStates = {
  AR: true,
  GA: true,
  ID: true,
  UT: true,
  MD: true,
  TN: true,
  TX: true,
  WY: true
};
export const noUMPDStates = {
  AL: true,
  AZ: true,
  FL: true,
  IA: true,
  KS: true,
  MA: true,
  KY: true,
  ME: true,
  MI: true,
  MO: true,
  MT: true,
  ND: true,
  NE: true,
  NH: true,
  PA: true,
  SD: true,
  WY: true
};

export const noMedPayStates = {
  AR: true,
  DC: true,
  MI: true,
  MD: true,
  ND: true,
  OR: true,
  UT: true
};

export const doNotShowCarLevelUMPDStates = {
  ...policyLevelUMPDStates,
  ...noUMPDStates
};

// When adding a new state to windstormMitigationDiscountStates, also add the options to windstormMitigationLevelValues.json
export const windstormMitigationDiscountStates = { AL: true, MS: true };
export const windstormMitigationDiscountYearBuilt = 2006;
export const windstormMitigationDefinitionsLinkStates = {
  MS: 'https://app.getguru.com/card/ijAxGaRT/Mississippi-Wind-Mitigation-Discount-Definitions'
};

export const pullAutoDataOnlyForAutoPolicyStates = {
  AK: true,
  DC: true,
  GA: true,
  MA: true,
  ND: true,
  NH: true,
  SC: true,
  VT: true
};

/** States that allow day care coverage add-ons */
export const dayCareStates = ['MD', 'NE'];

/** CCW violation type */
export const CCWStates = { AL: true };

/** Document type constants used across frontend and backend */
export const documentTypes = {
  APPLICATION: 0,
  POLICY_JACKET: 1,
  ID_CARDS: 2,
  DECLARATION: 3,
  FCRA_NOTICE: 4,
  CANCELLATION: 5,
  POLICY_MOD_CONFIRMATION: 6,
  RENEWAL: 7,
  CONVERSION: 8,
  UM_NOTICE: 9, // UMRJ - UM Rejection Form
  MEDPAY: 10, // MEDP - MedPay Selection/Rejection Form
  PIP_NOTICE: 11, // PIPS - Notice of Waiver of Personal Injury Protection
  // 12 retired (BIX_CONVERSION_NON_RENEWAL, removed #31350) — do not reuse; may exist in historic records
  NDEL_NOTICE: 13, // NDEL - Named Driver Exclusion Election Form
  INVOICE: 14,
  REPLACEMENT_COST_ESTIMATE: 15,
  SUBSCRIBER_AGREEMENT: 16,
  PIP_SELECTION_FORM: 17, // PIPS - PIP Selection Form
  REFUSAL_TO_WRITE: 18,
  NON_RENEWAL: 19,
  TORT_SELECTION: 20, // TOSF - Tort Selection Rejection Form
  PIP_NO_FAULT_REJECTION: 21,
  MPSF: 22, // MPSF - MI Selection of Personal Injury Protection
  WORK_LOSS_BENEFITS_WAIVER: 23, // WLBW - Michigan Work Loss Benefits Waiver
  KY_NO_FAULT_REJECTION: 24, // KNFR - Kentucky No Fault Rejection
  EXCESS_UM_UIM_SELECTION_REJECTION_FORM: 25, // EUSF - Excess UM/UIM Selection/Rejection Form
  NAMED_DRIVER_EXCLUSION: 26, // NDEX - Named Driver Exclusion
  LOUISIANA_DEDUCTIBLE_NOTICE: 27, // LADN - Louisiana Deductible Notice
  RATING_INFORMATION_NOTICE: 28, // NOTC - Notice of Tort Options
  MINE_SUBSIDENCE: 29, // OH and IL
  MINE_SUBSIDENCE_SELECTION_REJECTION: 30, // IN and KY
  COAL_MINE_SUBSIDENCE_WAIVER: 31, // WV
  LOSS_OF_INCOME_WAIVER: 32, // UT
  COLLISION_DEDUCTIBLE_WAIVER: 33, // PA
  MINE_SUBSIDENCE_SELECTION_FORM: 34, // MNSF - Mine Subsidence Selection Form
  NOTICE_OF_TORT_OPTIONS: 35, // NOTC - Notice of Tort Options
  UIM_SELECTION_FORM: 36, // UIMS - UIM Selection Form
  UM_UIM_SELECTION_REJECTION_FORM: 37, // UMSF - UM or UM/UIM Selection Rejection Form
  MINE_SUBSIDENCE_INSURANCE_APPLICATION: 38, // MINA - Mine Subsidence Insurance Underwriting Association Application
  DRIVER_ATTESTATION: 39, // A_DRAT Unverified driver attestation
  FARM_POLICY_PACKET: 40, // Combined Farm policy PDF: cover + dec + jacket + filed forms
  // Farm (CFM / Forreston) policy-lifecycle notices routed through the Zywave DocGen pipeline
  // (issue #34574). Company/Fair-Plan/Non-Pay cancellation, Non-Renewal and the Reinstatement Offer
  // ride the existing CANCELLATION docType (5) via the farm cancellation-handler; these three have
  // their own trigger paths (AOR affinity-mapping create, an NSF daily cron, and reinstatement
  // confirmation respectively) so they need their own docTypes + handlers.
  AGENT_OF_RECORD: 41, // F/Z/Y_AORC — Agent-of-Record change confirmation letter
  NSF_VOID: 42, // F/Z/Y_NSFV — NSF (returned payment) void notice
  REINSTATEMENT_NOTICE: 43, // F/Z/Y_REIN — policy reinstated after payment received
  REINSTATEMENT_OFFER: 44, // F/Z/Y_ROFR — equity-based reinstatement offer (renewal lapse)
  // Mutual (CFM / Forreston) recurring payment authorization form (#35891): the brand's static PDF,
  // attached as its own member-visible document when a policy switches onto automated card/ACH
  // billing. Saved under the B_AUTH doc name so friendly-name mapping matches the legacy Branch form.
  RECURRING_PAYMENT_AUTH: 45,
  // CFM driver-age forms (#36352 / #36348): the ACORD 92 Medical Statement (A_MEDS, rated drivers
  // 76+) and the Doctor / Physician Statement (A_PHYS, 81+), overlaid per driver and attached as
  // their own member-visible documents when an endorsement adds such a driver.
  DRIVER_AGE_FORMS: 46,
  NON_PAY_PENDING_NOTICE: 47, // F/Z/Y_NPPN — non-pay legal notice sent before any cancellation is booked (#36240)
  CONFIRMATION_OF_CANCELLATION: 48 // F/Z/Y_CONF — sent when a mutual non-pay cancellation takes effect (#36240)
};

/**
 * Max length of an editable document display label, shared by frontend and backend.
 * Enforced by the get-docs set-document-label lambda. S3 tag values max out at 256
 * chars and base64 inflates by ~4/3, so we cap the raw label well under that ceiling.
 */
export const MAX_DOCUMENT_LABEL_LENGTH = 150;

/** Document types that require signature */
export const docTypesThatNeedSignature = [
  documentTypes.UM_NOTICE, // UMRJ - UM Rejection Form
  documentTypes.MEDPAY, // MEDP - MedPay Selection/Rejection Form
  documentTypes.PIP_NOTICE, // PIPS - Notice of Waiver of Personal Injury Protection
  documentTypes.NDEL_NOTICE, // NDEL - Named Driver Exclusion Election Form
  documentTypes.MPSF, // MPSF - Selection of Personal Injury Protection
  documentTypes.WORK_LOSS_BENEFITS_WAIVER, // WLBW - Work Loss Benefits Waiver
  documentTypes.KY_NO_FAULT_REJECTION, // KNFR - Kentucky No Fault Rejection
  documentTypes.TORT_SELECTION, // TOSF - Tort Selection Rejection Form
  documentTypes.EXCESS_UM_UIM_SELECTION_REJECTION_FORM, // EUSF - Excess UM/UIM Selection/Rejection Form
  documentTypes.PIP_SELECTION_FORM, // PIPS - PIP Selection Form
  documentTypes.COLLISION_DEDUCTIBLE_WAIVER, // CODW - Collision Deductible Waiver
  documentTypes.LOSS_OF_INCOME_WAIVER, // LOIW - Loss of Income Waiver
  documentTypes.MINE_SUBSIDENCE_SELECTION_FORM, // MNSF - Mine Subsidence Selection Form
  documentTypes.COAL_MINE_SUBSIDENCE_WAIVER, // CMSL - Coal Mine Subsidence Waiver
  documentTypes.NAMED_DRIVER_EXCLUSION, // NDEX - Named Driver Exclusion
  documentTypes.LOUISIANA_DEDUCTIBLE_NOTICE, // LADN - Louisiana Deductible Notice
  documentTypes.NOTICE_OF_TORT_OPTIONS, // NOTC - Notice of Tort Options
  documentTypes.UIM_SELECTION_FORM, // UIMS - UIM Selection Form
  documentTypes.UM_UIM_SELECTION_REJECTION_FORM, // UMSF - UM or UM/UIM Selection Rejection Form
  documentTypes.MINE_SUBSIDENCE_INSURANCE_APPLICATION, // MINA - Mine Subsidence Insurance Underwriting Association Application
  documentTypes.RATING_INFORMATION_NOTICE,
  documentTypes.DRIVER_ATTESTATION // A_DRAT - Undisclosed Driver Attestation
];

/** Driver removal reason codes used across frontend and backend */
export const driverRemovedReasons = {
  PENDING_VERIFICATION: 'PENDING_VERIFICATION',
  CONFIRMED_DRIVER: 'CONFIRMED_DRIVER',
  REMOVED_BY_API_NEEDS_MEMBER_REVIEW: 'REMOVED_BY_API_NEEDS_MEMBER_REVIEW',
  PRIOR_OWNER: 'PRIOR_OWNER',
  NON_LICENSED: 'NON_LICENSED',
  MILITARY_AWAY: 'MILITARY_AWAY',
  RESIDENT_RELATIVE_OWN_INS: 'RESIDENT_RELATIVE_OWN_INS',
  DECEASED: 'DECEASED',
  NON_RELATIVE: 'NON_RELATIVE',
  DUPLICATE: 'DUPLICATE',
  UNKNOWN: 'UNKNOWN'
};

// Per-carrier alternative credit (ISM7U) algorithm config. Each carrier declares which
// states use the alt-credit TU algorithm (state -> effective start date, YYYYMMDD) and
// whether the alt path skips non-primary (co-applicant) credit.
//   - branch: legacy reopening-era states; alt path skips co-app credit (PNI only).
//   - cfm: MO only, always alt; pulls BOTH applicants (joint score = better of two, #31724).
// MD: Maryland transitions to alternative credit scoring starting September 20, 2025.
interface AltCreditCarrierConfig {
  states: Record<string, number>;
  skipNonPrimaryInAltStates: boolean;
}

export const altCreditAlgorithmByCarrier: Record<string, AltCreditCarrierConfig> = {
  branch: {
    states: { KS: 19000101, FL: 19000101, MD: 20250920, SC: 19000101 },
    skipNonPrimaryInAltStates: true
  },
  cfm: {
    states: { MO: 19000101 },
    skipNonPrimaryInAltStates: false
  }
};

// Backwards-compatible alias: existing readers that key on Branch's state map keep working.
export const altCreditAlgorithmStatesDates = altCreditAlgorithmByCarrier.branch.states;

const getAltCreditConfig = (carrier?: string): AltCreditCarrierConfig =>
  altCreditAlgorithmByCarrier[carrier ?? 'branch'] ?? altCreditAlgorithmByCarrier.branch;

// Whether `state` uses the alt-credit (ISM7U) algorithm for `carrier` as of `rateControlDateInt` (YYYYMMDD).
export const isAltCreditState = (carrier: string | undefined, state: string, rateControlDateInt: number): boolean => {
  const date = getAltCreditConfig(carrier).states[state];
  return !!date && rateControlDateInt >= date;
};

// Whether the carrier's alt-credit path skips non-primary (co-applicant) credit.
export const skipNonPrimaryCreditInAltState = (carrier?: string): boolean =>
  getAltCreditConfig(carrier).skipNonPrimaryInAltStates;

export const noCreditStates = {
  MA: true
};

export const raterLOBCodes = {
  GA: {
    H: {
      19000101: '01',
      20250522: 'BXGAH02'
    }
  }
};

export const flatInstallmentFee = 3;

export const noPPCExclusionStates = { KY: true, MI: true, NH: true };

// Extended this constant to support getting different values by policy type
// to support gradual reopenings per policy type like GA
// If there is no override of days for a particular state and policy type it will return 7 days as the default
export const soldToEffectiveDaysIntervalByState = (state: string, policyType: string) => {
  const defaultDaysOut = 7;
  const data = {
    AR: () => 1,
    AZ: () => 1,
    DC: () => 1,
    IA: () => 1,
    IL: () => 1,
    IN: () => 1,
    KY: () => 1,
    MO: () => 1,
    MT: () => 1,
    ND: () => 1,
    NE: () => 1,
    NM: () => 1,
    OH: () => 1,
    OK: () => 1,
    OR: () => 1,
    TX: () => 1,
    UT: () => 1,
    WI: () => 1,
    GA: () => 1
  };

  const stateFunc = (<any>data)[state];
  return stateFunc ? stateFunc(policyType) : defaultDaysOut;
};

// Advance Quote Days (AQD) map states to use instead of FED
// When a state is in this map, FED messaging/discount should never appear for any policy type.
// Only policy types marked `true` will show the AQD discount.
export const advanceQuoteDaysStates = {
  AZ: { A: true, H: false },
  IA: { A: true, H: false },
  IL: { A: true, H: false },
  KY: { A: true, H: false },
  MD: { A: true, H: false },
  MI: { A: true, H: false },
  MO: { A: true, H: false },
  MT: { A: true, H: false },
  NE: { A: true, H: false },
  OH: { A: true, H: false },
  OK: { A: true, H: false },
  OR: { A: true, H: false },
  UT: { A: true, H: false },
  WI: { A: true, H: false }
};

export const waterBackupNameByState = {
  MD: 'Sewer Backup'
};

// these are the states in which we want to force pulling MVRs before binding
// This constant is also used for preBindCredit data pulls on co applicants
export const preBindMVRStates = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'NM',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
];

// States where home eligibility depends on blended credit score (co-applicant credit must be pulled)
export const homeEligibilityBasedOnBlendedCreditScoreStates = ['GA'];

export const driverCarAssignmentStates = {
  MA: true,
  VA: true,
  VT: true
};

export const minLimitRentalStates = {
  AL: 40,
  AR: 40,
  AZ: 40,
  CO: 40,
  DC: 40,
  GA: 40,
  IA: 40,
  ID: 40,
  IL: 40,
  IN: 40,
  KS: 40,
  KY: 40,
  LA: 40,
  MA: 40,
  MD: 40,
  ME: 40,
  MI: 40,
  MO: 40,
  MS: 40,
  MT: 40,
  ND: 40,
  NE: 40,
  NH: 40,
  NM: 40,
  OH: 40,
  OK: 40,
  OR: 40,
  PA: 40,
  SC: 40,
  SD: 40,
  TN: 40,
  TX: 40,
  UT: 40,
  VA: 600,
  VT: 40,
  WI: 40,
  WV: 40,
  WY: 40
};

export const allowInstallPayOnHomePoliciesStates = {
  AR: true,
  AZ: true,
  GA: true,
  IA: true,
  IL: true,
  IN: true,
  KY: true,
  LA: true,
  MD: true,
  MO: true,
  MT: true,
  ND: true,
  NE: true,
  NM: true,
  OH: true,
  OR: true,
  UT: true,
  WI: true
};

export const onlyPayInFullOnAutoPoliciesStates = {
  PA: true
};

export const basementTypes = {
  Slab: 'S',
  Raised: 'R',
  Unfinished: 'U',
  PartialFinished: 'PF',
  FullFinished: 'FF'
};

export enum GarageTypes {
  ATTACHED_BUILT_IN = '1',
  CARPORT = '2',
  BASEMENT = '3',
  DETACHED_NONE = 'X'
}

export const uninsuredMotoristDefaultStates = {
  VT: '1000000'
};

export const canRejectPIPStates = ['KY'];

export const pipDefaultStates = {
  AR: 'NONE',
  DC: 'NONE',
  FL: '0 NI',
  KS: '4500',
  KY: '10000/0DED',
  MA: '250HH',
  ND: '30',
  OR: 'NONE'
};

// States with non-standard Personal Injury Protection Work Loss (PIPWL) values:
// See lookups package for the values
export const statesWithNonStandardPIPWLValues = ['DC', 'FL'];

export const leaseLoanStates = {
  AL: { isBix: true, isNotBix: true },
  AR: { isBix: true, isNotBix: true },
  AZ: { isBix: true, isNotBix: false },
  CO: { isBix: true, isNotBix: true },
  DC: { isBix: true, isNotBix: true },
  FL: { isBix: true, isNotBix: true },
  GA: { isBix: true, isNotBix: true },
  IA: { isBix: true, isNotBix: true },
  ID: { isBix: true, isNotBix: true },
  IL: { isBix: true, isNotBix: false },
  IN: { isBix: true, isNotBix: true },
  KS: { isBix: true, isNotBix: true },
  KY: { isBix: true, isNotBix: true },
  LA: { isBix: false, isNotBix: false },
  MA: { isBix: true, isNotBix: true },
  MD: { isBix: true, isNotBix: true },
  ME: { isBix: true, isNotBix: true },
  MI: { isBix: true, isNotBix: true },
  MO: { isBix: true, isNotBix: false },
  MS: { isBix: true, isNotBix: true },
  MT: { isBix: true, isNotBix: true },
  ND: { isBix: true, isNotBix: true },
  NE: { isBix: true, isNotBix: true },
  NH: { isBix: true, isNotBix: true },
  NM: { isBix: true, isNotBix: true },
  OH: { isBix: true, isNotBix: false },
  OK: { isBix: true, isNotBix: true },
  OR: { isBix: true, isNotBix: true },
  PA: { isBix: true, isNotBix: true },
  SC: { isBix: true, isNotBix: true },
  SD: { isBix: true, isNotBix: true },
  TN: { isBix: true, isNotBix: true },
  TX: { isBix: true, isNotBix: false },
  UT: { isBix: true, isNotBix: true },
  VA: { isBix: true, isNotBix: true },
  VT: { isBix: true, isNotBix: true },
  WI: { isBix: true, isNotBix: true },
  WV: { isBix: true, isNotBix: true },
  WY: { isBix: true, isNotBix: true }
};

export const advancedConnectedHomeStates = {
  AL: { isBix: true, isNotBix: true },
  AR: { isBix: true, isNotBix: true },
  AZ: { isBix: true, isNotBix: false },
  CO: { isBix: true, isNotBix: true },
  DC: { isBix: true, isNotBix: true },
  GA: { isBix: true, isNotBix: true },
  IA: { isBix: true, isNotBix: true },
  ID: { isBix: true, isNotBix: true },
  IL: { isBix: true, isNotBix: false },
  IN: { isBix: true, isNotBix: false },
  KS: { isBix: true, isNotBix: true },
  KY: { isBix: true, isNotBix: true },
  LA: { isBix: true, isNotBix: true },
  MA: { isBix: true, isNotBix: true },
  MD: { isBix: true, isNotBix: true },
  ME: { isBix: true, isNotBix: true },
  MI: { isBix: true, isNotBix: true },
  MO: { isBix: true, isNotBix: false },
  MS: { isBix: true, isNotBix: true },
  MT: { isBix: true, isNotBix: true },
  ND: { isBix: true, isNotBix: true },
  NE: { isBix: true, isNotBix: true },
  NH: { isBix: true, isNotBix: true },
  NM: { isBix: true, isNotBix: true },
  OH: { isBix: true, isNotBix: false },
  OK: { isBix: true, isNotBix: false },
  OR: { isBix: true, isNotBix: true },
  PA: { isBix: true, isNotBix: true },
  SC: { isBix: true, isNotBix: true },
  SD: { isBix: true, isNotBix: true },
  TN: { isBix: true, isNotBix: true },
  TX: { isBix: true, isNotBix: false },
  UT: { isBix: true, isNotBix: true },
  VT: { isBix: true, isNotBix: true },
  VA: { isBix: true, isNotBix: true },
  WI: { isBix: true, isNotBix: true },
  WV: { isBix: true, isNotBix: true },
  WY: { isBix: true, isNotBix: true }
};

export const discountInventoryScoreStates = {
  AL: { isBix: true, isNotBix: true },
  AR: { isBix: true, isNotBix: true },
  AZ: { isBix: true, isNotBix: false },
  CO: { isBix: true, isNotBix: true },
  DC: { isBix: true, isNotBix: true },
  GA: { isBix: true, isNotBix: true },
  IA: { isBix: true, isNotBix: true },
  ID: { isBix: true, isNotBix: true },
  IL: { isBix: true, isNotBix: true },
  IN: { isBix: true, isNotBix: false },
  KS: { isBix: true, isNotBix: true },
  KY: { isBix: true, isNotBix: true },
  LA: { isBix: true, isNotBix: true },
  MA: { isBix: false, isNotBix: false },
  MD: { isBix: true, isNotBix: true },
  ME: { isBix: true, isNotBix: true },
  MI: { isBix: true, isNotBix: true },
  MO: { isBix: true, isNotBix: false },
  MS: { isBix: true, isNotBix: true },
  MT: { isBix: true, isNotBix: true },
  ND: { isBix: true, isNotBix: true },
  NE: { isBix: true, isNotBix: true },
  NH: { isBix: true, isNotBix: true },
  NM: { isBix: true, isNotBix: true },
  OH: { isBix: true, isNotBix: false },
  OR: { isBix: true, isNotBix: true },
  OK: { isBix: true, isNotBix: false },
  PA: { isBix: true, isNotBix: true },
  SC: { isBix: true, isNotBix: true },
  SD: { isBix: true, isNotBix: true },
  TN: { isBix: true, isNotBix: true },
  TX: { isBix: true, isNotBix: false },
  UT: { isBix: true, isNotBix: true },
  VT: { isBix: true, isNotBix: true },
  VA: { isBix: true, isNotBix: true },
  WI: { isBix: true, isNotBix: true },
  WV: { isBix: true, isNotBix: true },
  WY: { isBix: true, isNotBix: true }
};

export const discountPaperlessStates = {
  AL: { isBix: true, isNotBix: true },
  AR: { isBix: true, isNotBix: true },
  AZ: { isBix: true, isNotBix: false },
  CO: { isBix: true, isNotBix: true },
  DC: { isBix: true, isNotBix: true },
  GA: { isBix: true, isNotBix: true },
  IA: { isBix: true, isNotBix: true },
  ID: { isBix: true, isNotBix: true },
  IL: { isBix: true, isNotBix: false },
  IN: { isBix: true, isNotBix: false },
  KS: { isBix: true, isNotBix: true },
  KY: { isBix: true, isNotBix: true },
  LA: { isBix: true, isNotBix: true },
  MA: { isBix: true, isNotBix: true },
  ME: { isBix: true, isNotBix: true },
  MD: { isBix: true, isNotBix: true },
  MI: { isBix: true, isNotBix: true },
  MO: { isBix: true, isNotBix: false },
  MS: { isBix: true, isNotBix: true },
  MT: { isBix: true, isNotBix: true },
  ND: { isBix: true, isNotBix: true },
  NE: { isBix: true, isNotBix: true },
  NH: { isBix: true, isNotBix: true },
  NM: { isBix: true, isNotBix: true },
  OH: { isBix: true, isNotBix: false },
  OK: { isBix: true, isNotBix: false },
  OR: { isBix: true, isNotBix: true },
  PA: { isBix: true, isNotBix: true },
  SC: { isBix: true, isNotBix: true },
  SD: { isBix: true, isNotBix: true },
  TN: { isBix: true, isNotBix: true },
  TX: { isBix: true, isNotBix: false },
  UT: { isBix: true, isNotBix: true },
  VA: { isBix: true, isNotBix: true },
  VT: { isBix: true, isNotBix: true },
  WI: { isBix: true, isNotBix: true },
  WV: { isBix: true, isNotBix: true },
  WY: { isBix: true, isNotBix: true }
};

export const pipStates = {
  AR: true,
  DC: false,
  FL: true,
  KS: true,
  KY: true,
  MA: true,
  MD: true,
  ND: true,
  OR: true,
  TX: true,
  UT: true
};

export const accidentalDeathStates = {
  PA: true,
  SD: true
};

// policy-level income loss here only:
export const incomeLossStates = {
  DC: true,
  PA: true,
  SD: true,
  VA: true
};

// Shared policy-level coverage placement, used by quote-fe and state-rules (#32137).
export const policyLevelLPDStates = ['MI'];
export const policyLevelPIPMEStates = ['MI'];
export const policyLevelPIPACRStates = ['MI'];
export const policyLevelPIPWLStates = ['MI'];
export const policyLevelFuneralBenefitsStates = ['DC', 'PA'];
export const policyLevelExtraMedBenefitsStates = ['DC', 'PA'];
export const policyLevelTortOptionStates = ['PA'];
export const policyLevelComboFBPStates = ['PA'];

export const UMPDMustBePDOrLessStates = ['GA', 'MS'];

export const changeRejectionLangToNeedToTalkStates = { NH: true, FL: true };
export const changeRejectionLangToNeedToTalkPhoneNumberStates = {
  FL: '8442276528'
};

/**
 *
 * @description states where community drive will be removed after 15 days if member does not register/activate in the app
 */
export const communityDriveRemoveAfter15DaysStates = [
  'AR',
  'AZ',
  'GA',
  'IA',
  'IL',
  'IN',
  'KY',
  'LA',
  'MD',
  'MI',
  'MO',
  'MS',
  'MT',
  'ND',
  'NE',
  'NM',
  'OH',
  'OK',
  'PA',
  'TX',
  'WI',
  'WV'
];

export const communityDriveAvailableStates = {
  AL: { showForBix: true, showForNonBix: true },
  AR: { showForBix: true, showForNonBix: true },
  AZ: { showForBix: true, showForNonBix: false },
  CO: { showForBix: true, showForNonBix: true },
  DC: { showForBix: true, showForNonBix: true },
  GA: { showForBix: true, showForNonBix: true },
  IA: { showForBix: true, showForNonBix: true },
  ID: { showForBix: true, showForNonBix: true },
  IL: { showForBix: true, showForNonBix: false },
  IN: { showForBix: true, showForNonBix: true },
  KS: { showForBix: true, showForNonBix: true },
  KY: { showForBix: true, showForNonBix: true },
  LA: { showForBix: true, showForNonBix: true },
  MA: { showForBix: true, showForNonBix: true },
  MD: { showForBix: true, showForNonBix: true },
  ME: { showForBix: true, showForNonBix: true },
  MI: { showForBix: true, showForNonBix: true },
  MO: { showForBix: true, showForNonBix: false },
  MS: { showForBix: true, showForNonBix: true },
  MT: { showForBix: true, showForNonBix: true },
  ND: { showForBix: true, showForNonBix: true },
  NE: { showForBix: true, showForNonBix: true },
  NH: { showForBix: true, showForNonBix: true },
  NM: { showForBix: true, showForNonBix: true },
  OH: { showForBix: true, showForNonBix: false },
  OK: { showForBix: true, showForNonBix: true },
  OR: { showForBix: true, showForNonBix: true },
  PA: { showForBix: true, showForNonBix: true },
  SC: { showForBix: true, showForNonBix: true },
  SD: { showForBix: true, showForNonBix: true },
  TN: { showForBix: true, showForNonBix: true },
  TX: { showForBix: true, showForNonBix: false },
  UT: { showForBix: true, showForNonBix: true },
  VA: { showForBix: false, showForNonBix: false },
  VT: { showForBix: true, showForNonBix: true },
  WI: { showForBix: true, showForNonBix: true },
  WV: { showForBix: true, showForNonBix: true },
  WY: { showForBix: true, showForNonBix: true }
};

export const errorCodes = {
  CHAT: 4000,
  EMAIL: 4001,
  POWER: 4002,
  NOTLIVE: 4003,
  NOT_ENOUGH_INFO: 4004,
  INVALIDINPUT: 4005,
  NEEDPRIORADDRESS: 5001,
  NEEDDATEOFBIRTH: 5002,
  NEEDCV: 5003,
  NEED360: 5004,
  NEEDCAR: 5005,
  INVALIDCAR: 5006,
  INVALIDQUOTE: 5007,
  INVALIDSTATE: 5008,
  WONTWRITECAR: 5009,
  INVALIDVIN: 5010,
  MORATORIUM: 5011,
  NEEDDRIVERSLICENSE: 5012,
  NOPOBOXADDRESS: 5013,
  MIN_PREMIUM: 5014,
  PRIMARYUDRNODRIVERSLICENSE: 5015,
  NEEDPERSONINFO: 5016,
  RESTRICTEDSTATE: 5017,
  SETFEES: 5018,
  SUSPICIOUSQUOTE: 5019,
  BLANKQUOTE: 5020,
  QUOTELIMITEXCEEDED: 5021,
  SECOND_TIME_PRIOR_CANCEL_NON_PAY: 5022,
  MISSING_LAT_LNG: 5023,
  INVALID_ZIP_CODE: 5024,
  NEEDAPTUNIT: 5025,
  CANNOTQUOTEONLINE: 5026,
  NBZIP: 5027,
  NOT_ALLOWED_TO_QUOTE_IN_STATE: 5028,
  RESTRICTED_STATE_FOR_DIRECT: 5029,
  OLD_OFFER: 5030,
  RIDESHARING_RESTRICTION: 5031,
  UNABLE_TO_BUNDLE: 5032,
  API_TRIED_TO_RECALCULATE_OFFER_WITH_NO_OPTIONS: 5033,
  AUX_RATING: 5034,
  RATE_LIMIT_QUOTE: 5035,
  AFFINITY_DISABLED: 5036,
  // Catch-all for errors we couldn't otherwise classify. A self-describing string (not the old
  // falsy `0`, and not a real numeric reject code like 5010/INVALIDVIN which was previously misused
  // as the default — see quote-fe/src/checkout/checkout-error-codes.md, issue #31299). Frontend
  // `formattedError` and the checkout `error_code` fallback both resolve to this.
  UNKNOWN: 'UNKNOWN',
  // Transport failure with no HTTP status (offline, timeout, DNS/CORS). `formattedError` emits
  // `HTTP_<status>` when a status is present and falls back to this otherwise.
  NETWORK_ERROR: 'NETWORK_ERROR',
  MSRP_TOO_HIGH: 5037,
  TOO_MANY_VIOLATIONS: 5038,
  MARYLAND_DEDUCTIBLE: 5039,
  PARTNERLINK_NOT_ALLOWED_IN_STATE: 5040,
  BRANCH_PLUS_CARRIER_ERROR: 5041,
  FARM_RATING_ERROR: 5042,
  BRAND_STATE_NOT_SUPPORTED: 5043,
  MULTI_LOCATION_STATE_MISMATCH: 5044,
  CD_RATING_FACTOR_NOT_FOUND: 5045,
  FARM_EFFECTIVE_DATE_TOO_EARLY: 5046,
  NOPRODUCT: 5047,
  // Transient search-infrastructure (Meilisearch) failure — safe to retry the request as-is
  SEARCH_SERVICE_UNAVAILABLE: 5048,
  OFFER_NOT_FOUND: 5049,
  AFFINITY_NOT_ALLOWED_IN_STATE: 5050,
  // Transient credit-bureau (TransUnion) infrastructure/config failure — e.g. the mTLS private key
  // is missing/malformed or no longer matches the client cert. Historically this threw
  // ERR_OSSL_UNSUPPORTED / ERR_OSSL_X509_KEY_VALUES_MISMATCH from a TLS socket event, escaping the
  // rater's request-level try/catch and exiting the whole process (Runtime.ExitError). Now surfaced
  // as a typed, retryable error instead of crashing all quoting (issue #34920).
  CREDIT_SERVICE_UNAVAILABLE: 5051,
  // Transient ClarionDoor / rating-vendor failure (cluster unreachable, Driver Factor 747 "multi transfer
  // error responses", credentials errors that survived the repository's retries) — safe to retry the
  // request as-is; replaces the 4001 catch-all for these (#35917).
  CD_SERVICE_UNAVAILABLE: 5052,
  // Some version of this quote has already been bound (#35936): sending it to underwriting or
  // binding it again would create a duplicate policy. Not retryable — open the existing policy.
  OFFER_ALREADY_PURCHASED: 5053,
  // A brand that cannot write new-business auto before a launch date (CFM: 11/1/2026, #37461).
  AUTO_EFFECTIVE_DATE_TOO_EARLY: 5054
} as const;

export const preBindRejections = {
  EXISTING_MEMBER: 'EXISTING_MEMBER',
  MVR_RETRY: 'MVR_RETRY',
  MVR_DRIVERS_CHANGED: 'MVR_DRIVERS_CHANGED',
  MVR_REJECTED: 'MVR_REJECTED'
} as const;

export const errorClassificationLookup = {
  4000: 'BLOCK',
  4001: 'BLOCK',
  4002: 'BLOCK',
  4003: 'BLOCK',
  4004: 'BLOCK',
  4005: 'BLOCK',
  5001: 'ALERT',
  5002: 'ALERT',
  5003: 'ALERT',
  5004: 'ALERT',
  5005: 'ALERT',
  5006: 'ALERT',
  5008: 'BLOCK',
  50055: 'DISMISSIBLE_REJECTION',
  50096: 'DISMISSIBLE_REJECTION',
  50097: 'DISMISSIBLE_REJECTION',
  50098: 'DISMISSIBLE_REJECTION',
  5009: 'ALERT',
  5010: 'ALERT',
  5011: 'BLOCK',
  5012: 'ALERT',
  5013: 'ALERT',
  5014: 'BLOCK',
  5015: 'ALERT',
  5016: 'ALERT',
  5017: 'BLOCK',
  5018: 'BLOCK',
  5019: 'BLOCK',
  5020: 'BLOCK',
  5021: 'BLOCK',
  5022: 'BLOCK',
  5023: 'ALERT',
  5024: 'ALERT',
  5025: 'ALERT',
  5026: 'BLOCK',
  5027: 'BLOCK',
  5028: 'BLOCK',
  5029: 'BLOCK',
  5030: 'BLOCK',
  5031: 'BLOCK',
  5032: 'BLOCK',
  5033: 'BLOCK',
  5034: 'BLOCK',
  5035: 'BLOCK',
  5036: 'BLOCK',
  5037: 'BLOCK',
  5038: 'BLOCK',
  5039: 'BLOCK',
  5040: 'BLOCK',
  5041: 'BLOCK',
  5042: 'BLOCK',
  5043: 'BLOCK',
  5044: 'BLOCK',
  5045: 'BLOCK',
  5047: 'BLOCK',
  // BLOCK = blocking error UI, not "permanent": 5048 is transient infra failure — the user/partner
  // resubmits the request; the FE never auto-retries and ALERT-family would imply an input fix
  5048: 'BLOCK',
  5049: 'BLOCK',
  5050: 'BLOCK',
  // 5051 is a transient credit-bureau infra/config failure — same rationale as 5048: blocking UI so
  // the user resubmits, no auto-retry, not presented as a resolvable input problem (issue #34920)
  5051: 'BLOCK',
  // 5052 is a transient ClarionDoor / rating-vendor failure — same rationale as 5048/5051 (#35917)
  5052: 'BLOCK',
  // 5053: a policy already exists for this quote — nothing to fix on the offer, go to the policy (#35936)
  5053: 'BLOCK',
  50001: 'BYPASS_ALERT',
  50006: 'BYPASS_ALERT',
  // Unclassifiable / transport errors are treated as blocking (don't present them as resolvable).
  [errorCodes.UNKNOWN]: 'BLOCK',
  [errorCodes.NETWORK_ERROR]: 'BLOCK'
};

export const rejectCodes = {
  // all codes from 10000 - 49999 are FCRA
  VERISK_GENERIC: 10000,
  VERISK_PROPERTY_CLAIMS_TOTAL: 10009,
  VERISK_PROPERTY_CLAIMS_SAME_PERIL: 10010,
  VERISK_PROPERTY_CLAIMS_OLDER_HOME: 10011,
  VERISK_PROPERTY_CLAIMS_BITE: 10012,
  VERISK_AUTO_CLAIMS_SUS: 10013,
  VERISK_AUTO_CLAIMS_DIS: 10014,
  VERISK_AUTO_CLAIMS_POLICY: 10015,
  VERISK_AUTO_CLAIMS_DRIVER: 10016,
  VERISK_PIP_CLAIMS: 10017,
  VERISK_AUTO_CLAIMS_FEL: 10018,
  VERISK_RENTERS_HOME_CLAIMS_THREE_YEARS: 10019,
  VERISK_RENTERS_HOME_WATER_LOSSES: 10020,
  VERISK_PROPERTY_CLAIMS_WATER_LOSSES: 10021,

  TU_DRIVERRISK_GENERIC: 20000,
  TU_DRIVERRISK_SUS: 20001,
  TU_DRIVERRISK_DIS: 20002,
  TU_DRIVERRISK_POLICY: 20003,
  TU_DRIVERRISK_DRIVER: 20004,
  TU_DRIVERRISK_FEL: 20005,

  // Non-FCRA rejections:
  NON_FCRA_GENERIC: 50000,
  NO_CARS: 50001,
  SQFT_HIGH: 50002,
  OCCUPANTS_HIGH: 50003,
  CAR_RATIO: 50004,
  YEARBUILT_OLD: 50005,
  VERISK_NO360: 50006,
  NO_PRIOR_AUTO_INSURANCE: 50007,
  VERISK_360_EIFS: 50008,
  VERISK_360_STILTS: 50009,
  VERISK_360_WOOD: 50010,
  VERISK_360_RCE_LOW: 50011,
  VERISK_360_RCE_HIGH: 50012,
  VERISK_PPC_10: 50013,
  VERISK_NO_PPC: 50014,
  TOO_MANY_DRIVERS: 50015,
  TOO_MANY_CARS: 50016,
  TEST_CASE: 50017,
  INELIGIBLE_COASTAL_LOCATION: 50018,
  VERISK_NO_FIRELINE: 50019,
  VERISK_FIRELINE_TOO_HIGH: 50020,
  VERISK_FIRELINE_PLUS_FPC_TOO_HIGH: 50021,
  NO_DTC: 50022,
  INELIGIBLE_DTC: 50023,
  SPP_OVER_10PCT_COVC: 50024,
  SPP_OVER_10PCT_COVA: 50025,
  SPP_TOTAL_OVER_50PCT_COVC: 50026,
  NO_HOME_WIND_HAIL_EXCLUSION: 50027,
  VERISK_PPC_TOO_HIGH: 50028,
  DID_NOT_ASK_FOR_AUTO: 50029,
  CAPE_ROOF_CONDITION: 50030,
  CAPE_YARD_DEBRIS: 50031,
  COASTAL_COUNTY: 50032,
  LESS_THAN_1YEAR_PC: 50033,
  INVALID_PRIOR_CARRIER: 50034,
  ANY_INCIDENTS_OR_VIOLATIONS: 50035,
  // note that we have removed this as of github issue 24289
  MORE_CARS_THAN_DRIVERS: 50036,
  // note that we have removed this as of github issue 24289
  BI_TOO_LOW: 50037,
  CV_NO_HIT: 50038,
  SOME_DRIVERS_EXCLUDED: 50039,
  // note that we have removed this as of github issue 24289
  INSURANCE_SCORE_LOW: 50040,
  SELF_REPORTED_HOME_UW_DISQUALIFIER: 50041,
  SELF_REPORTED_AUTO_UW_DISQUALIFIER: 50042,
  CONDO_RENTED_OUT_RESTRICTION: 50083,
  NO_MONOLINE_HOME: 50084,
  NO_MONOLINE_CONDO: 50085,
  NO_MONOLINE_AUTO: 50086,
  PRIMARY_AGE_RESTRICTION: 50087,
  SECONDARY_HOME: 50088,
  HOME_MUST_BE_CLEAN: 50089,
  VERISK_360_RCE_PLUS_IBSC_HIGH: 50094,
  RISK_CONCENTRATION: 50095,
  PROPERTY_MISMATCH: 50096,
  NO_COMMERCIAL_PROPERTIES: 50097,
  UNSUPPORTED_PROPERTY: 50098,
  NEED_PRIOR_AUTO_COVERAGE_DETAILS: 50099,
  PROPERTY_OWNED_BY_CORP_LLC_LP_LLP_ESTATE_OR_PARTNERSHIP: 50055,

  // API rejections
  API_HOME_FAILED_IN_HA_BUNDLE: 50090,
  API_AUTO_FAILED_IN_HA_BUNDLE: 50091,
  API_CONDO_FAILED_IN_CA_BUNDLE: 50092,
  API_AUTO_FAILED_IN_CA_BUNDLE: 50093,

  // Restarting numbering of new codes
  HAS_AUX_RATING: 50100,
  GREATER_THAN_MINIMUM_ACRES: 50101,
  HOME_CHARACTERISTIC_ASBESTOS: 50102,
  HISTORIC_HOME: 50103,
  BRANDED_TITLE: 50104,
  VACANT_HOME: 50105,
  UNSUPPORTED_ROOF_MATERIAL: 50106,
  FORECLOSURE_HIT: 50107,
  POLICY_TYPE_BLOCKED_FOR_AFFINITY_IN_THIS_STATE: 50108,
  RADIUS_RISK_CONCENTRATION: 50109,
  STRICT_TOP_LEVEL_GRID_RISK_CONCENTRATION: 50110,
  STRICT_MID_LEVEL_GRID_RISK_CONCENTRATION: 50111,
  TOP_LEVEL_GRID_RISK_CONCENTRATION: 50112,
  MID_LEVEL_GRID_RISK_CONCENTRATION: 50113,
  ROOF_TOO_OLD: 50114,
  MORATORIUM_ZIP_CODE: 50115,
  HOME_LOW_MARKET_VALUE: 50116,
  MSRP_TOO_HIGH: 50117,
  WONT_WRITE_CAR: 50118,
  VERISK_PPC_9: 50119,
  DAY_CARE_COVERAGE_NEEDS_UW_APPROVAL: 50120,

  // Florida Rejections

  // Home
  // If any is added, remember to add it also in "floridaHomeSoftRejectCodes" or "floridaHomeHardRejectCodes"
  // The ones without FL_ prefix are country wide
  FL_WATER_HEATER_AGE_GREATER_THAN_15_YEARS: 50043,
  FL_COV_A_LESS_THAN_100000: 50044,
  FL_TRAMPOLINES_PRESENT: 50045,
  FL_GREATER_THAN_5_ACRES_OR_PC_9_OR_10: 50046,
  FL_MOBILE_PREFABRICATED_HOMES_LOG_OR_UNCONVENTIONAL_CONSTRUCTION: 50047,
  FL_HOMES_WITH_INELIGIBLE_DOG_BREED_OR_BITE_AGGRESSION_HISTORY: 50048,
  FL_PRIOR_SINKHOLE_ACTIVITY_OR_ADJACENT_TO_KNOWN_SINKHOLES: 50049,
  FL_SADDLE_ANIMALS_FARM_OR_NON_DOMESTICATED_ANIMALS: 50050,
  FL_OPEN_FOUNDATIONS: 50051,
  FL_PROPERTY_IS_IN_FORECLOSURE: 50052,
  FL_POLYBUTYLENE_PLUMBING: 50053,
  FL_SKATEBOARD_RAMP_DIVING_BOARD_BIKE_RAMP_POOL_SLIDE: 50054,
  // Alias for backward compatibility - this code is now used globally, not just for FL
  FL_PROPERTY_OWNED_BY_CORP_LLC_LP_LLP_ESTATE_OR_PARTNERSHIP: 50055,
  FL_EXCLUDE_CONTENT_COVERAGE: 50056,
  FL_RUN_DAY_CARE_OUT_OF_MY_HOME: 50057,
  FL_SEASONAL_OR_SECONDARY_HOME: 50058,
  FL_MORE_THAN_2_MORTGAGES: 50059,
  FL_COMMERCIAL_OCCUPATION: 50060,
  FL_HOME_GREATER_THAN_40_YEARS: 50061,
  FL_SHINGLE_OR_WOOD_ROOF: 50062,
  FL_INELIGIBLE_OCCUPANCY: 50063,
  FL_FLAT_ROOFS: 50064,
  FL_TILE_OR_METAL_ROOFS_GREATER_THAN_25: 50065,
  FL_PRIOR_LOSS_IN_5_YEARS: 50066,
  FL_TWO_PROPERTY_OR_LIABILITY_LOSSES: 50067,
  FL_NO_PRIOR_INSURANCE: 50068,
  FL_PRIOR_POLICY_WAS_CANCELLED_OR_NON_RENEWED: 50069,
  FL_COV_A_GREATER_THAN_950K: 50070,
  FL_REQUESTED_SINKHOLE_COVERAGE: 50071,
  FL_UNCONVENTIONAL_CONSTRUCTION_OR_DEFECTIVE_MATERIALS: 50072,
  FL_NO_HOME_WIND_HAIL_EXCLUSION: 50073,

  // Auto
  // If any is added, remember to add it also in "floridaAutoSoftRejectCodes" or "floridaAutoHardRejectCodes"
  // The ones without FL_ prefix are country wide
  FL_EXCLUDE_BI_COVERAGE: 50074,
  FL_LAPSE_GREATER_THAN_2_DAYS: 50075,
  FL_MORE_THAN_1_PIP_CLAIM_PAST_3_YEARS: 50076,
  FL_MORE_THAN_1_AT_FAULT_ACCIDENT_PAST_3_YEARS: 50077,
  FL_MORE_THAN_2_ACCIDENTS_REGARDLESS_OF_FAULT_PAST_3_YEARS: 50078,
  FL_MORE_THAN_2_INFRACTIONS_PAST_3_YEARS: 50079,
  FL_INSURANCE_SCORE_IS_NO_HIT_OR_NO_SCORE: 50080,
  FL_MVR_IS_A_NO_HIT_OR_UDR: 50081,
  FL_NEED_SR22: 50082,
  BRAND_STATE_NOT_SUPPORTED: 50083,
  MULTI_LOCATION_STATE_MISMATCH: 50084,

  // Farm and errors added after we started building farm (was confusing to have these above)
  FARM_HIGH_TOTAL_INSURED_VALUE: 50121,
  FARM_LOCATION_HIGH_TOTAL_INSURED_VALUE: 50122,
  YEARBUILT_OLD_UNDER_100: 50123,
  UT_HIGH_RISK_WILDFIRE_BOUNDARY: 50124,
  FARM_MISSING_PRIMARY_STATE: 50125,
  APLUS_ANTI_FRAUD_INDICATOR: 50126,
  INVALID_FARM_LOCATION_ADDRESS: 50127,
  FARM_MAX_DWELLING_RISKS_EXCEEDED: 50128,
  FARM_MAX_ACRES_EXCEEDED: 50129,
  FARM_EFFECTIVE_DATE_TOO_EARLY: 50130,
  // Home (Z) / Rental (Y) must insure a dwelling (FO-1/2/3, plus FO-4 for Home). A policy with only
  // other structures (FO-6) is ineligible. Hard rejection — not in softRejectCodes. (#32514)
  // FORRESTON ONLY. CFM raises FARM_MISSING_INSURED_PROPERTY instead — an FO-6 alone is an eligible
  // CFM Home/Rental (#34260).
  FARM_MISSING_DWELLING: 50131,
  // Secondary home/condo in a secondaryHomeStrictLossHistoryStates state with a single
  // water/theft/liability/vandalism loss in the trailing 3 years. Hard rejection (overridable via
  // overridesForUW) — intentionally stricter than the primary-residence loss allowance. (#32689)
  SECONDARY_HOME_LOSS_HISTORY: 50132,
  // Earthquake coverage elected in a "must approve" zip (CFM MO EQ Zone 2). Soft rejection — the
  // offer proceeds to underwriting for review before bind. (#32439)
  FARM_EARTHQUAKE_ZONE_APPROVAL_REQUIRED: 50133,
  // Inland Flood elected without Water Backup at the same limit (CFM MO). The filing requires
  // the two to match. Soft rejection — staff correct the limit, they don't lose the offer. (#33373)
  FARM_INLAND_FLOOD_WATER_BACKUP_MISMATCH: 50138,
  // Structure too large for ClarionDoor to rate as a dwelling (e.g. an apartment/commercial building
  // submitted as a home). Its roof_size (CD factor 11003), roof_replacement_cost (CD factor 10993) or
  // raw sq_ft_fixed_expense (CD factor 178) exceeds CD's rate-table bands, which otherwise throws an
  // opaque "Unable to locate factors" (4001/5045). HARD rejection — deliberately NOT in softRejectCodes,
  // so it stays hard on API/RC1 quotes and flips offerHomeowners(false) before rating (a soft rejection
  // would not, and home would still hit CD, taking a monoline-A auto quote down with it).
  // Not the retired SQFT_HIGH (#32965): thresholds sit far above any real dwelling. (#33104, #34190)
  STRUCTURE_TOO_LARGE_TO_RATE: 50134,
  // Forreston does not write Home/Rental/Farm risks located in a set of restricted Illinois
  // counties (Cook, Will, DuPage, Lake, Kane, Kendall, Grundy). Keyed off the risk/location
  // address county, not the mailing address. HARD rejection — deliberately NOT in softRejectCodes,
  // and (unlike the other farm checks) it is applied even during a policy modification so
  // endorsements and existing-policy updates into a restricted county are blocked too. (#33239)
  FARM_RESTRICTED_COUNTY: 50135,
  // Standalone inland marine risk with zero SPP items — soft, in farmSoftRejectCodes; see
  // docs/farm-standalone-inland-marine.md. (#33165)
  FARM_INLAND_MARINE_NO_ITEMS: 50136,
  // A CFM Home (Z) / Rental (Y) policy insures no property at all — no dwelling, no structure, no
  // renters risk. An FO-6 alone IS eligible on CFM (#34260), so this is deliberately weaker than
  // FARM_MISSING_DWELLING above, which stays Forreston-only. It still rejects the risk-less shape,
  // because liability-only is a Farm-only product (#33169). Hard rejection — NOT in
  // farmSoftRejectCodes. (#34260)
  FARM_MISSING_INSURED_PROPERTY: 50137,
  AUTO_COVERAGE_LAPSE: 50139,
  // New-business auto effective before the brand's autoMinimumEffectiveDate (CFM: 11/1/2026, #37461).
  AUTO_EFFECTIVE_DATE_TOO_EARLY: 50140
} as const;

export const softRejectCodes = [
  rejectCodes.FARM_INLAND_FLOOD_WATER_BACKUP_MISMATCH,
  rejectCodes.OCCUPANTS_HIGH,
  rejectCodes.NO_PRIOR_AUTO_INSURANCE,
  rejectCodes.VERISK_360_EIFS,
  rejectCodes.VERISK_360_STILTS,
  rejectCodes.VERISK_360_WOOD,
  rejectCodes.VERISK_360_RCE_LOW,
  rejectCodes.VERISK_360_RCE_HIGH,
  rejectCodes.SPP_OVER_10PCT_COVC,
  rejectCodes.SPP_OVER_10PCT_COVA,
  rejectCodes.SPP_TOTAL_OVER_50PCT_COVC,
  rejectCodes.CAPE_ROOF_CONDITION,
  rejectCodes.CAPE_YARD_DEBRIS,
  rejectCodes.LESS_THAN_1YEAR_PC,
  rejectCodes.INVALID_PRIOR_CARRIER,
  rejectCodes.MORE_CARS_THAN_DRIVERS,
  rejectCodes.SELF_REPORTED_HOME_UW_DISQUALIFIER,
  rejectCodes.FL_FLAT_ROOFS,
  rejectCodes.SECONDARY_HOME,
  rejectCodes.PROPERTY_MISMATCH,
  rejectCodes.NO_COMMERCIAL_PROPERTIES,
  rejectCodes.PROPERTY_OWNED_BY_CORP_LLC_LP_LLP_ESTATE_OR_PARTNERSHIP,
  rejectCodes.UNSUPPORTED_PROPERTY,
  rejectCodes.HAS_AUX_RATING,
  rejectCodes.HOME_CHARACTERISTIC_ASBESTOS,
  rejectCodes.HISTORIC_HOME,
  rejectCodes.BRANDED_TITLE,
  rejectCodes.VACANT_HOME,
  rejectCodes.UNSUPPORTED_ROOF_MATERIAL,
  rejectCodes.FORECLOSURE_HIT,
  rejectCodes.VERISK_360_RCE_PLUS_IBSC_HIGH,
  rejectCodes.BI_TOO_LOW,
  rejectCodes.CAR_RATIO,
  rejectCodes.NEED_PRIOR_AUTO_COVERAGE_DETAILS,
  rejectCodes.MORATORIUM_ZIP_CODE,
  rejectCodes.HOME_LOW_MARKET_VALUE,
  rejectCodes.TOO_MANY_CARS,
  rejectCodes.MSRP_TOO_HIGH,
  rejectCodes.ROOF_TOO_OLD,
  rejectCodes.WONT_WRITE_CAR,
  rejectCodes.YEARBUILT_OLD_UNDER_100,
  rejectCodes.APLUS_ANTI_FRAUD_INDICATOR,
  rejectCodes.AUTO_COVERAGE_LAPSE
];

export const floridaHomeSoftRejectCodes = [
  rejectCodes.FL_WATER_HEATER_AGE_GREATER_THAN_15_YEARS,
  rejectCodes.FL_COV_A_LESS_THAN_100000,
  rejectCodes.FL_GREATER_THAN_5_ACRES_OR_PC_9_OR_10,
  rejectCodes.FL_RUN_DAY_CARE_OUT_OF_MY_HOME,
  rejectCodes.FL_HOME_GREATER_THAN_40_YEARS,
  rejectCodes.FL_SHINGLE_OR_WOOD_ROOF,
  rejectCodes.FL_FLAT_ROOFS,
  rejectCodes.FL_PRIOR_LOSS_IN_5_YEARS,
  rejectCodes.FL_NO_PRIOR_INSURANCE,
  rejectCodes.FL_PRIOR_POLICY_WAS_CANCELLED_OR_NON_RENEWED,
  rejectCodes.FL_REQUESTED_SINKHOLE_COVERAGE,
  rejectCodes.FL_COV_A_GREATER_THAN_950K,
  rejectCodes.FL_EXCLUDE_CONTENT_COVERAGE,
  rejectCodes.FL_NO_HOME_WIND_HAIL_EXCLUSION,
  rejectCodes.FL_SEASONAL_OR_SECONDARY_HOME
];

export const floridaHomeHardRejectCodes = [
  rejectCodes.FL_TRAMPOLINES_PRESENT,
  rejectCodes.FL_MOBILE_PREFABRICATED_HOMES_LOG_OR_UNCONVENTIONAL_CONSTRUCTION,
  rejectCodes.FL_HOMES_WITH_INELIGIBLE_DOG_BREED_OR_BITE_AGGRESSION_HISTORY,
  rejectCodes.FL_PRIOR_SINKHOLE_ACTIVITY_OR_ADJACENT_TO_KNOWN_SINKHOLES,
  rejectCodes.FL_SADDLE_ANIMALS_FARM_OR_NON_DOMESTICATED_ANIMALS,
  rejectCodes.FL_OPEN_FOUNDATIONS,
  rejectCodes.FL_PROPERTY_IS_IN_FORECLOSURE,
  rejectCodes.FL_SKATEBOARD_RAMP_DIVING_BOARD_BIKE_RAMP_POOL_SLIDE,
  rejectCodes.FL_PROPERTY_OWNED_BY_CORP_LLC_LP_LLP_ESTATE_OR_PARTNERSHIP,
  rejectCodes.FL_POLYBUTYLENE_PLUMBING,
  rejectCodes.FL_MORE_THAN_2_MORTGAGES,
  rejectCodes.FL_TILE_OR_METAL_ROOFS_GREATER_THAN_25,
  rejectCodes.FL_TWO_PROPERTY_OR_LIABILITY_LOSSES,
  rejectCodes.FL_INELIGIBLE_OCCUPANCY,
  rejectCodes.FL_UNCONVENTIONAL_CONSTRUCTION_OR_DEFECTIVE_MATERIALS,
  rejectCodes.FL_COMMERCIAL_OCCUPATION,
  rejectCodes.INELIGIBLE_DTC
];

export const floridaAutoSoftRejectCodes = [
  rejectCodes.FL_EXCLUDE_BI_COVERAGE,
  rejectCodes.FL_LAPSE_GREATER_THAN_2_DAYS,
  rejectCodes.FL_INSURANCE_SCORE_IS_NO_HIT_OR_NO_SCORE,
  rejectCodes.FL_MVR_IS_A_NO_HIT_OR_UDR
];

export const floridaAutoHardRejectCodes = [
  rejectCodes.FL_NEED_SR22,
  rejectCodes.FL_MORE_THAN_1_PIP_CLAIM_PAST_3_YEARS,
  rejectCodes.FL_MORE_THAN_1_AT_FAULT_ACCIDENT_PAST_3_YEARS,
  rejectCodes.FL_MORE_THAN_2_ACCIDENTS_REGARDLESS_OF_FAULT_PAST_3_YEARS,
  rejectCodes.FL_MORE_THAN_2_INFRACTIONS_PAST_3_YEARS,
  rejectCodes.INELIGIBLE_DTC,
  rejectCodes.INELIGIBLE_COASTAL_LOCATION
];

export const monolineAutoRejectCodes = [
  rejectCodes.LESS_THAN_1YEAR_PC,
  rejectCodes.CV_NO_HIT,
  rejectCodes.INVALID_PRIOR_CARRIER,
  rejectCodes.ANY_INCIDENTS_OR_VIOLATIONS,
  rejectCodes.MORE_CARS_THAN_DRIVERS,
  rejectCodes.BI_TOO_LOW,
  rejectCodes.SOME_DRIVERS_EXCLUDED,
  rejectCodes.INSURANCE_SCORE_LOW
];

/**
 * Maps rejection codes to their rejection types.
 * Used to automatically determine rejection type from code without requiring a suffix.
 *
 * For ambiguous codes that could apply to multiple types (e.g., VERISK_360_* for Home/Condo),
 * defaults to Home to match existing behavior.
 */
export const rejectionCodeToTypeMap: Record<
  number,
  'auto' | 'home' | 'condo' | 'renters' | 'monoline' | 'monoline-home' | 'monoline-condo'
> = {
  // Auto-specific codes - FCRA Auto codes
  [rejectCodes.VERISK_AUTO_CLAIMS_SUS]: 'auto',
  [rejectCodes.VERISK_AUTO_CLAIMS_DIS]: 'auto',
  [rejectCodes.VERISK_AUTO_CLAIMS_POLICY]: 'auto',
  [rejectCodes.VERISK_AUTO_CLAIMS_DRIVER]: 'auto',
  [rejectCodes.VERISK_PIP_CLAIMS]: 'auto',
  [rejectCodes.VERISK_AUTO_CLAIMS_FEL]: 'auto',
  // Auto-specific codes - TU Driver Risk codes
  [rejectCodes.TU_DRIVERRISK_GENERIC]: 'auto',
  [rejectCodes.TU_DRIVERRISK_SUS]: 'auto',
  [rejectCodes.TU_DRIVERRISK_DIS]: 'auto',
  [rejectCodes.TU_DRIVERRISK_POLICY]: 'auto',
  [rejectCodes.TU_DRIVERRISK_DRIVER]: 'auto',
  [rejectCodes.TU_DRIVERRISK_FEL]: 'auto',
  // Auto-specific codes - Non-FCRA Auto codes
  [rejectCodes.NO_CARS]: 'auto',
  [rejectCodes.NO_PRIOR_AUTO_INSURANCE]: 'auto',
  [rejectCodes.AUTO_COVERAGE_LAPSE]: 'auto',
  [rejectCodes.TOO_MANY_DRIVERS]: 'auto',
  [rejectCodes.TOO_MANY_CARS]: 'auto',
  [rejectCodes.DID_NOT_ASK_FOR_AUTO]: 'auto',
  [rejectCodes.SELF_REPORTED_AUTO_UW_DISQUALIFIER]: 'auto',
  [rejectCodes.NO_MONOLINE_AUTO]: 'monoline',
  [rejectCodes.API_AUTO_FAILED_IN_HA_BUNDLE]: 'auto',
  [rejectCodes.API_AUTO_FAILED_IN_CA_BUNDLE]: 'auto',
  [rejectCodes.BRANDED_TITLE]: 'auto',
  [rejectCodes.MSRP_TOO_HIGH]: 'auto',
  [rejectCodes.WONT_WRITE_CAR]: 'auto',
  // Auto-specific codes - Florida Auto codes
  [rejectCodes.FL_EXCLUDE_BI_COVERAGE]: 'auto',
  [rejectCodes.FL_LAPSE_GREATER_THAN_2_DAYS]: 'auto',
  [rejectCodes.FL_INSURANCE_SCORE_IS_NO_HIT_OR_NO_SCORE]: 'auto',
  [rejectCodes.FL_MVR_IS_A_NO_HIT_OR_UDR]: 'auto',
  [rejectCodes.FL_NEED_SR22]: 'auto',
  [rejectCodes.FL_MORE_THAN_1_PIP_CLAIM_PAST_3_YEARS]: 'auto',
  [rejectCodes.FL_MORE_THAN_1_AT_FAULT_ACCIDENT_PAST_3_YEARS]: 'auto',
  [rejectCodes.FL_MORE_THAN_2_ACCIDENTS_REGARDLESS_OF_FAULT_PAST_3_YEARS]: 'auto',
  [rejectCodes.FL_MORE_THAN_2_INFRACTIONS_PAST_3_YEARS]: 'auto',
  // Auto-specific codes - Monoline Auto codes
  [rejectCodes.LESS_THAN_1YEAR_PC]: 'monoline',
  [rejectCodes.CV_NO_HIT]: 'monoline',
  [rejectCodes.INVALID_PRIOR_CARRIER]: 'monoline',
  [rejectCodes.ANY_INCIDENTS_OR_VIOLATIONS]: 'monoline',
  [rejectCodes.MORE_CARS_THAN_DRIVERS]: 'monoline',
  [rejectCodes.BI_TOO_LOW]: 'monoline',
  [rejectCodes.SOME_DRIVERS_EXCLUDED]: 'monoline',
  [rejectCodes.INSURANCE_SCORE_LOW]: 'monoline',

  // Renters-specific codes
  [rejectCodes.VERISK_RENTERS_HOME_CLAIMS_THREE_YEARS]: 'renters',
  [rejectCodes.VERISK_RENTERS_HOME_WATER_LOSSES]: 'renters',

  // Condo-specific codes
  [rejectCodes.CONDO_RENTED_OUT_RESTRICTION]: 'condo',
  [rejectCodes.NO_MONOLINE_CONDO]: 'monoline-condo',
  [rejectCodes.API_CONDO_FAILED_IN_CA_BUNDLE]: 'condo',

  // Home-specific codes - FCRA Property codes
  [rejectCodes.VERISK_PROPERTY_CLAIMS_TOTAL]: 'home',
  [rejectCodes.VERISK_PROPERTY_CLAIMS_SAME_PERIL]: 'home',
  [rejectCodes.VERISK_PROPERTY_CLAIMS_OLDER_HOME]: 'home',
  [rejectCodes.VERISK_PROPERTY_CLAIMS_BITE]: 'home',
  [rejectCodes.VERISK_PROPERTY_CLAIMS_WATER_LOSSES]: 'home',
  // Home-specific codes - Non-FCRA Home codes
  [rejectCodes.SQFT_HIGH]: 'home',
  [rejectCodes.VERISK_NO360]: 'home',
  [rejectCodes.VERISK_NO_FIRELINE]: 'home',
  [rejectCodes.VERISK_FIRELINE_TOO_HIGH]: 'home',
  [rejectCodes.VERISK_FIRELINE_PLUS_FPC_TOO_HIGH]: 'home',
  [rejectCodes.SPP_OVER_10PCT_COVC]: 'home',
  [rejectCodes.SPP_TOTAL_OVER_50PCT_COVC]: 'home',
  [rejectCodes.NO_HOME_WIND_HAIL_EXCLUSION]: 'home',
  [rejectCodes.CAPE_ROOF_CONDITION]: 'home',
  [rejectCodes.CAPE_YARD_DEBRIS]: 'home',
  [rejectCodes.SELF_REPORTED_HOME_UW_DISQUALIFIER]: 'home',
  [rejectCodes.NO_MONOLINE_HOME]: 'monoline-home',
  [rejectCodes.SECONDARY_HOME]: 'home',
  [rejectCodes.SECONDARY_HOME_LOSS_HISTORY]: 'home',
  [rejectCodes.HOME_MUST_BE_CLEAN]: 'home',
  [rejectCodes.API_HOME_FAILED_IN_HA_BUNDLE]: 'home',
  [rejectCodes.HAS_AUX_RATING]: 'home',
  [rejectCodes.GREATER_THAN_MINIMUM_ACRES]: 'home',
  [rejectCodes.HOME_CHARACTERISTIC_ASBESTOS]: 'home',
  [rejectCodes.HISTORIC_HOME]: 'home',
  [rejectCodes.VACANT_HOME]: 'home',
  [rejectCodes.UNSUPPORTED_ROOF_MATERIAL]: 'home',
  [rejectCodes.FORECLOSURE_HIT]: 'home',
  [rejectCodes.ROOF_TOO_OLD]: 'home',
  [rejectCodes.HOME_LOW_MARKET_VALUE]: 'home',
  [rejectCodes.FARM_HIGH_TOTAL_INSURED_VALUE]: 'home',
  [rejectCodes.FARM_LOCATION_HIGH_TOTAL_INSURED_VALUE]: 'home',
  [rejectCodes.YEARBUILT_OLD_UNDER_100]: 'home',
  [rejectCodes.UT_HIGH_RISK_WILDFIRE_BOUNDARY]: 'home',
  // Home-specific codes - Florida Home codes
  [rejectCodes.FL_WATER_HEATER_AGE_GREATER_THAN_15_YEARS]: 'home',
  [rejectCodes.FL_COV_A_LESS_THAN_100000]: 'home',
  [rejectCodes.FL_TRAMPOLINES_PRESENT]: 'home',
  [rejectCodes.FL_GREATER_THAN_5_ACRES_OR_PC_9_OR_10]: 'home',
  [rejectCodes.FL_MOBILE_PREFABRICATED_HOMES_LOG_OR_UNCONVENTIONAL_CONSTRUCTION]: 'home',
  [rejectCodes.FL_HOMES_WITH_INELIGIBLE_DOG_BREED_OR_BITE_AGGRESSION_HISTORY]: 'home',
  [rejectCodes.FL_PRIOR_SINKHOLE_ACTIVITY_OR_ADJACENT_TO_KNOWN_SINKHOLES]: 'home',
  [rejectCodes.FL_SADDLE_ANIMALS_FARM_OR_NON_DOMESTICATED_ANIMALS]: 'home',
  [rejectCodes.FL_OPEN_FOUNDATIONS]: 'home',
  [rejectCodes.FL_PROPERTY_IS_IN_FORECLOSURE]: 'home',
  [rejectCodes.FL_POLYBUTYLENE_PLUMBING]: 'home',
  [rejectCodes.FL_SKATEBOARD_RAMP_DIVING_BOARD_BIKE_RAMP_POOL_SLIDE]: 'home',
  [rejectCodes.FL_PROPERTY_OWNED_BY_CORP_LLC_LP_LLP_ESTATE_OR_PARTNERSHIP]: 'home',
  [rejectCodes.FL_EXCLUDE_CONTENT_COVERAGE]: 'home',
  [rejectCodes.FL_RUN_DAY_CARE_OUT_OF_MY_HOME]: 'home',
  [rejectCodes.FL_SEASONAL_OR_SECONDARY_HOME]: 'home',
  [rejectCodes.FL_MORE_THAN_2_MORTGAGES]: 'home',
  [rejectCodes.FL_COMMERCIAL_OCCUPATION]: 'home',
  [rejectCodes.FL_HOME_GREATER_THAN_40_YEARS]: 'home',
  [rejectCodes.FL_SHINGLE_OR_WOOD_ROOF]: 'home',
  [rejectCodes.FL_INELIGIBLE_OCCUPANCY]: 'home',
  [rejectCodes.FL_FLAT_ROOFS]: 'home',
  [rejectCodes.FL_TILE_OR_METAL_ROOFS_GREATER_THAN_25]: 'home',
  [rejectCodes.FL_PRIOR_LOSS_IN_5_YEARS]: 'home',
  [rejectCodes.FL_TWO_PROPERTY_OR_LIABILITY_LOSSES]: 'home',
  [rejectCodes.FL_NO_PRIOR_INSURANCE]: 'home',
  [rejectCodes.FL_PRIOR_POLICY_WAS_CANCELLED_OR_NON_RENEWED]: 'home',
  [rejectCodes.FL_COV_A_GREATER_THAN_950K]: 'home',
  [rejectCodes.FL_REQUESTED_SINKHOLE_COVERAGE]: 'home',
  [rejectCodes.FL_UNCONVENTIONAL_CONSTRUCTION_OR_DEFECTIVE_MATERIALS]: 'home',
  [rejectCodes.FL_NO_HOME_WIND_HAIL_EXCLUSION]: 'home'
};

// Specific set of Reject Codes that are set somewhere but need to be cleared in Staff
export const rejectCodesToBeClearedInStaff = [rejectCodes.NO_HOME_WIND_HAIL_EXCLUSION];

export const fixableRejectionCodes = [50001, 50004, 50006, 50014, 50015, 50016, 50022];

export const restrictedBLimitsStates = [];
export const restrictedCLimitsStates = ['DC', 'LA', 'ME', 'NH', 'SD', 'VT'];
export const restrictedDLimitsStates = ['DC', 'LA', 'ME', 'MS', 'ND', 'NH', 'SD', 'VT'];
export const unlimitedDLimitsStates = ['CO'];
export const UNLIMITED_D_VALUE = -9999;
// Home Coverage D (% of Coverage A) values ClarionDoor has no loss-of-use factor (147) row for, by state, mapped
// to the rated option to use instead. Rating one fails the quote with "Unable to locate factors for factor id
// [147]". Found by replaying prod home requests at every option against CD on 2026-10-27 (#37211; also #34669).
export const coverageDUnratedPctReplacementsByState: Record<string, Record<number, number>> = {
  MD: { 0: 5 }
};

export const coverageFOffered = {
  AL: true,
  AR: true,
  AZ: false,
  CO: true,
  DC: true,
  GA: true,
  IA: true,
  ID: true,
  IL: true,
  IN: true,
  KS: true,
  KY: true,
  LA: true,
  MA: true,
  MD: true,
  MI: true,
  MO: true,
  MS: true,
  MT: true,
  ND: true,
  ME: true,
  NE: true,
  NH: true,
  NM: true,
  OH: true,
  OK: true,
  OR: true,
  PA: true,
  SC: true,
  SD: true,
  TN: true,
  TX: true,
  UT: true,
  VA: true,
  VT: true,
  WI: true,
  WV: true,
  WY: true
};

export const coverageDNotOffered = {
  DC: true,
  ME: true,
  MS: true,
  NH: true,
  SD: true,
  VT: true
};

export const coverageCANotOffered = {
  VA: true
};
export const coverageDRNotOffered = {
  ID: true,
  MA: true,
  ME: true,
  NH: true,
  TN: true,
  SD: true,
  VT: true,
  WY: true
};
export const coverageMINotOffered = {
  VA: true
};
export const coverageSTNotOffered = {
  ME: true,
  ND: true,
  NH: true,
  VA: true,
  VT: true
};
export const coverageSPNotOffered = {
  VA: true
};
export const coverageFairRentalNotOffered = {
  VA: true
};
export const coverageYardAndGardenNotOffered = {
  DC: true,
  SD: true,
  VA: true
};
export const coverageHomeownerProtectionNotOffered = {
  DC: true,
  ND: true,
  VA: true
};

export const offerExcessUM = {
  AL: false,
  AR: true,
  AZ: true,
  CO: false,
  DC: false,
  GA: false,
  IA: false,
  ID: false,
  IL: false,
  IN: true,
  KS: false,
  KY: false,
  LA: true,
  MA: false,
  MD: true,
  ME: false,
  MI: false,
  MO: false,
  MS: false,
  MT: true,
  ND: false,
  NE: true,
  NH: true,
  NM: false,
  OH: true,
  OK: true,
  OR: true,
  PA: false,
  SC: false,
  SD: false,
  TN: false,
  TX: true,
  UT: false,
  VA: false,
  VT: true,
  WI: false,
  WV: true,
  WY: false
};

export const mineSubsidenceOptional = {
  IL: {
    all: true
  },
  IN: {
    CLAY: true,
    CRAWFORD: true,
    DAVIES: true,
    DAVIESS: true,
    DUBOIS: true,
    FOUNTAIN: true,
    GIBSON: true,
    GREENE: true,
    KNOX: true,
    LAWRENCE: true,
    MARTIN: true,
    MONROE: true,
    MONTGOMERY: true,
    ORANGE: true,
    OWEN: true,
    PARKE: true,
    PERRY: true,
    PIKE: true,
    POSEY: true,
    PUTNAM: true,
    SPENCER: true,
    SULLIVAN: true,
    VANDERBURG: true,
    VANDERBURGH: true,
    VERMILION: true,
    VERMILLION: true,
    VIGO: true,
    WARREN: true,
    WARRICK: true
  },
  KY: {
    BELL: true,
    BOYD: true,
    BREATHITT: true,
    BUTLER: true,
    CARTER: true,
    CHRISTIAN: true,
    CLAY: true,
    DAVIESS: true,
    EDMONSON: true,
    ELLIOT: true,
    FLOYD: true,
    GREENUP: true,
    HANCOCK: true,
    HARLAN: true,
    HENDERSON: true,
    HOPKINS: true,
    JACKSON: true,
    JOHNSON: true,
    KNOTT: true,
    KNOX: true,
    LAUREL: true,
    LAWRENCE: true,
    LEE: true,
    LETCHER: true,
    LESLIE: true,
    MARTIN: true,
    MCCREARY: true,
    MCLEAN: true,
    MORGAN: true,
    MUHLENBERG: true,
    OHIO: true,
    OWSLEY: true,
    PERRY: true,
    UNION: true,
    WEBSTER: true,
    WHITLEY: true,
    WOLFE: true
  },
  OH: {
    DELAWARE: true,
    ERIE: true,
    GEAUGA: true,
    LAKE: true,
    LICKING: true,
    MEDINA: true,
    OTTAWA: true,
    PORTAGE: true,
    PREBLE: true,
    SUMMIT: true,
    WAYNE: true
  },
  WV: {
    BERKELEY: true,
    CABELL: true,
    CALHOUN: true,
    HAMPSHIRE: true,
    HARDY: true,
    JACKSON: true,
    JEFFERSON: true,
    MONROE: true,
    MORGAN: true,
    PENDLETON: true,
    PLEASANTS: true,
    RITCHIE: true,
    ROANE: true,
    WIRT: true,
    WOOD: true
  }
};

export const mineSubsidenceDefaulted = {
  IL: {
    BOND: true,
    BUREAU: true,
    CHRISTIAN: true,
    CLINTON: true,
    DOUGLAS: true,
    FRANKLIN: true,
    FULTON: true,
    GALLATIN: true,
    GRUNDY: true,
    ISLAND: true,
    JACKSON: true,
    JEFFERSON: true,
    KNOX: true,
    LASALLE: true,
    LOGAN: true,
    MACOUPIN: true,
    MADISON: true,
    MARION: true,
    MARSHALL: true,
    MCDONOUGH: true,
    MENARD: true,
    MERCER: true,
    MONTGOMERY: true,
    PEORIA: true,
    PERRY: true,
    PUTNAM: true,
    RANDOLPH: true,
    ROCK: true,
    'ROCK ISLAND': true,
    'SAINT CLAIR': true,
    SALINE: true,
    SANGAMON: true,
    'ST CLAIR': true,
    'ST. CLAIR': true,
    TAZEWELL: true,
    VERMILION: true,
    VERMILLION: true,
    WASHINGTON: true,
    WILLIAMSON: true
  }
};

export const mineSubsidenceRequired = {
  KY: {
    // stub placeholder to make this clear
    NONE: true
  },
  IN: {
    // stub placeholder to make this clear
    NONE: true
  },
  OH: {
    ATHENS: true,
    BELMONT: true,
    CARROLL: true,
    COLUMBIANA: true,
    COSHOCTON: true,
    GALLIA: true,
    GUERNSEY: true,
    HARRISON: true,
    HOCKING: true,
    HOLMES: true,
    JACKSON: true,
    JEFFERSON: true,
    LAWRENCE: true,
    MAHONING: true,
    MEIGS: true,
    MONROE: true,
    MORGAN: true,
    MUSKINGUM: true,
    NOBLE: true,
    PERRY: true,
    SCIOTO: true,
    STARK: true,
    TRUMBULL: true,
    TUSCARAWAS: true,
    VINTON: true,
    WASHINGTON: true
  },
  WV: {
    BARBOUR: true,
    BOONE: true,
    BRAXTON: true,
    BROOKE: true,
    CLAY: true,
    DODDRIDGE: true,
    FAYETTE: true,
    GILMER: true,
    GRANT: true,
    GREENBRIER: true,
    HANCOCK: true,
    HARRISON: true,
    KANAWHA: true,
    LEWIS: true,
    LINCOLN: true,
    LOGAN: true,
    MCDOWELL: true,
    MARION: true,
    MARSHALL: true,
    MASON: true,
    MERCER: true,
    MINERAL: true,
    MINGO: true,
    MONONGALIA: true,
    NICHOLAS: true,
    OHIO: true,
    POCAHONTAS: true,
    PRESTON: true,
    PUTNAM: true,
    RALEIGH: true,
    RANDOLPH: true,
    SUMMERS: true,
    TAYLOR: true,
    TUCKER: true,
    TYLER: true,
    UPSHUR: true,
    WAYNE: true,
    WEBSTER: true,
    WETZEL: true,
    WYOMING: true
  }
};

export const mandatoryWindHailDeductibleByZip = {};

export const mandatoryWindHailDeductibleByCounty = {
  LA: {
    AVOYELLES: 0.01,
    BIENVILLE: 0.01,
    BOSSIER: 0.01,
    CADDO: 0.01,
    CALDWELL: 0.01,
    CATAHOULA: 0.01,
    CLAIBORNE: 0.01,
    CONCORDIA: 0.01,
    'DE SOTO': 0.01,
    'EAST CARROLL': 0.01,
    FRANKLIN: 0.01,
    GRANT: 0.01,
    JACKSON: 0.01,
    LASallE: 0.01,
    LINCOLN: 0.01,
    LIVINGSTON: 0.01,
    MADISON: 0.01,
    MOREHOUSE: 0.01,
    NATCHITOCHES: 0.01,
    OUACHITA: 0.01,
    RAPIDES: 0.01,
    'RED RIVER': 0.01,
    RICHLAND: 0.01,
    SABINE: 0.01,
    TENSAS: 0.01,
    UNION: 0.01,
    VERNON: 0.01,
    WEBSTER: 0.01,
    'WEST CARROLL': 0.01,
    'WEST FELICIANA': 0.01,
    WINN: 0.01
  },
  MD: {
    ALLEGANY: 0.01,
    GARRETT: 0.01,
    WASHINGTON: 0.01,
    FREDERICK: 0.01,
    CARROLL: 0.01,
    HOWARD: 0.01,
    MONTGOMERY: 0.01,
    CHARLES: 0.01,
    'PRINCE GEORGES': 0.01,
    "PRINCE GEORGE'S": 0.01,
    'ANNE ARUNDEL': 0.01,
    BALTIMORE: 0.01,
    'BALTIMORE COUNTY': 0.01,
    'BALTIMORE CITY': 0.01,
    HARFORD: 0.01,
    CECIL: 0.01,
    KENT: 0.01,
    'QUEEN ANNES': 0.01,
    "QUEEN ANNE'S": 0.01,
    CAROLINE: 0.01,
    CALVERT: 0.02,
    'ST MARYS': 0.02,
    'ST. MARYS': 0.02,
    'SAINT MARYS': 0.02,
    "ST. MARY'S": 0.02,
    "ST MARY'S": 0.02,
    "SAINT MARY'S": 0.02,
    TALBOT: 0.02,
    DORCHESTER: 0.02,
    WICOMICO: 0.02,
    SOMERSET: 0.02,
    WORCESTER: 0.02
  },
  MO: {
    JEFFERSON: 0.01,
    'St. Louis': 0.01,
    'ST. LOUIS CITY': 0.01,
    'ST. LOUIS COUNTY': 0.01
  },
  MS: {
    ADAMS: 0.02,
    COVINGTON: 0.02,
    FRANKLIN: 0.02,
    GEORGE: 0.02,
    HANCOCK: 0.02,
    HARRISON: 0.02,
    JACKSON: 0.02,
    'JEFFERSON DAVIS': 0.02,
    JONES: 0.02,
    LAWRENCE: 0.02,
    LINCOLN: 0.02,
    'PEARL RIVER': 0.02,
    STONE: 0.02,
    WAYNE: 0.02
  }
};

export const aopDeductibleIsAlwaysPercent = {
  TN: false,
  WY: false
};

export const windHailDeductibleCanVaryByCounty = {
  GA: {
    BRYAN: true,
    CAMDEN: true,
    CHATHAM: true,
    GLYNN: true,
    LIBERTY: true,
    MCINTOSH: true
  }
};

export const noWindHailDeductibleStates = {
  DC: true,
  ND: true,
  SD: true,
  NH: true,
  TN: true,
  VT: true,
  WY: true
};

export const rentersPolicyAvailable = {
  AL: true,
  AR: true,
  AZ: true,
  CO: true,
  DC: false,
  FL: false,
  GA: true,
  IA: true,
  ID: true,
  IL: true,
  IN: true,
  KS: false,
  KY: false,
  LA: false,
  MA: false,
  MD: false,
  ME: false,
  MI: false,
  MO: true,
  MS: false,
  MT: false,
  ND: true,
  NE: true,
  NH: false,
  NM: true,
  OH: true,
  OK: true,
  OR: true,
  PA: true,
  SC: false,
  SD: false,
  TN: false,
  TX: false,
  UT: true,
  VA: true,
  VT: false,
  WI: true,
  WV: true,
  WY: false
};

export const standaloneRentersStates = {
  AZ: true,
  ND: true,
  NM: true,
  PA: true,
  CO: true
};

// Non-reopened states that allow next day effective date
export const nextDayEffectiveStates = {
  DC: true
};

export const condoStates = {
  AZ: true,
  MI: true,
  MO: true,
  OH: true,
  PA: true,
  WI: true
};

export const localPremiumTaxStates = {
  KY: true
};

export const statePremiumTaxStates = {
  KY: true
};

export const zeroPremiumTaxCities = {
  KY: {
    BARDSTOWN: true,
    BLAINE: true,
    BLOOMFIELD: true,
    BOONEVILLE: true,
    BREMEN: true,
    BUCKHORN: true,
    CAMARGO: true,
    CARRSVILLE: true,
    CLINTON: true,
    COLUMBUS: true,
    CONCORD: true,
    'CRESTVIEW HILLS': true,
    DRAKESBORO: true,
    EDGEWOOD: true,
    EUBANK: true,
    FAIRFIELD: true,
    FAIRVIEW: true,
    GERMANTOWN: true,
    'GRAND RIVERS': true,
    GRATZ: true,
    HARDIN: true,
    HAZEL: true,
    HOLLYVILLA: true,
    INDEPENDENCE: true,
    INEZ: true,
    'KENTON VALE': true,
    KEVIL: true,
    'LAKEVIEW HEIGHTS': true,
    MACKVILLE: true,
    MONTEREY: true,
    OWENTON: true,
    PIKEVILLE: true,
    'PIPPA PASSES': true,
    'POPLAR HILLS': true,
    RAYWICK: true,
    ROCHESTER: true,
    'SALT LICK': true,
    SARDIS: true,
    SHARPSBURG: true,
    SONORA: true,
    'SOUTH CARROLLTON': true,
    'SOUTH PARK VIEW': true,
    UNION: true,
    UPTON: true,
    WARFIELD: true,
    WAVERLY: true,
    WILLISBURG: true
  }
};

export const minimumDrivingAge = {
  AL: 15,
  AK: 14,
  AZ: 15,
  AR: 14,
  CA: 15,
  CO: 15,
  CT: 16,
  DE: 16,
  DC: 16,
  FL: 15,
  GA: 15,
  HI: 14,
  ID: 14,
  IL: 15,
  IN: 15,
  IA: 14,
  KS: 14,
  KY: 16,
  LA: 15,
  ME: 15,
  MD: 15,
  MA: 16,
  MI: 14,
  MN: 15,
  MS: 15,
  MO: 15,
  MT: 14,
  NE: 15,
  NV: 15,
  NH: 15,
  NJ: 16,
  NM: 16,
  NY: 16,
  NC: 15,
  ND: 14,
  OH: 15,
  OK: 15,
  OR: 15,
  PA: 16,
  RI: 16,
  SC: 15,
  SD: 14,
  TN: 15,
  TX: 15,
  UT: 15,
  VT: 15,
  VA: 15,
  WA: 15,
  WV: 15,
  WI: 15,
  WY: 15
};

export const vehicleEquipmentStatusCode = {
  OPTIONAL: 'O',
  STANDARD: 'S',
  NO: 'N'
};

export const HomeSecurityPartnerCustomerType = {
  CURRENT: 'C',
  NEW_BRANCH: 'B'
};

export const newCustomersDefaultDevices = {
  ADT: {
    moistureDevices: 2,
    theftPreventionDevices: 2,
    motionDetectingDevices: 1,
    smokeDetectingDevices: 2,
    autoWaterShutoffDevices: false
  },
  SimpliSafe: {
    moistureDevices: 1,
    theftPreventionDevices: 1,
    motionDetectingDevices: 1,
    smokeDetectingDevices: 1,
    autoWaterShutoffDevices: false
  }
};

export const connectedHomePromoDetails = {
  SimpliSafe: {
    promoItems: [
      '7-piece security system guards against break-ins and fires--plus includes 24/7 video monitoring. A $403 value, yours FREE.',
      'Monitored by professionals 24/7 for only $17.99/month - with NO long-term contract. Your first month is FREE.',
      'Ranked the best overall home security system of 2021 by U.S. News and World Report'
    ],
    privacyPolicyUrl: 'https://simplisafe.com/privacy'
  },
  ADT: {
    promoItems: [
      'Get ADTs best offer PLUS receive 2 flood detectors FREE (Requires 36 month monitoring contract. Early termination and installation fees apply.)',
      'ADT is the # 1 smart home security provider in the U.S. (Source: Strategy Analytics, 2020)',
      '$0 Down*** 0% Interest 100% Real Protection. Now you can get the security you need with the smart home devices you want with $0 down and flexible, easy, low monthly payments on professionally installed equipment. (***Requires 0% APR installment agreement with equal monthly payments based on term/equipment selected. Well-qualified credit. Requires monthly monitoring contract for finance term selected. Early term fees apply.)'
    ],
    privacyPolicyUrl: 'https://www.adt.com/about-adt/legal/privacy-policy'
  },
  Kangaroo: {
    privacyPolicyUrl: 'https://info.heykangaroo.com/legal#legal-privacy-policy'
  }
};

export const HighestEducation = {
  H: 'High School or less',
  S: 'Some College',
  A: 'Associates Degree',
  B: 'Bachelors Degree',
  M: 'Masters Degree',
  D: 'Doctoral Degree'
};

export const homeClaimCodeToDescription = {
  D: 'Fire',
  E: 'Theft, Liability, Vandalism',
  F: 'All Other Claims (not Fire, Water, Theft, Liability or Vandalism)',
  G: 'Water'
};

export const fpcClassesImpactingPrice = ['9'];
export const financialResponsibilityTiersImpactingPrice = ['L-1', 'M-1', 'N-1', 'O-1', 'P-1', 'Q-1', 'R-1'];
export const policyType = {
  Home: 'H',
  Auto: 'A',
  ARBundle: 'AR',
  HABundle: 'HA',
  Renters: 'R',
  Condo: 'C',
  CABundle: 'CA',
  HomeBundle: 'HB',
  AutoBundle: 'AB',
  Farm: 'F',
  FarmHome: 'Z',
  FarmRental: 'Y',
  FABundle: 'FA'
};

export const policyTypeLabels = { H: 'home', A: 'auto', R: 'rent', C: 'cond', F: 'farm', Z: 'fhom', Y: 'fren' };
/**
 * Lowercase policy type names used as object key prefixes (e.g., 'homeMegaDownPay', 'autoTotalPremium').
 * FarmHome (Z) and FarmRental (Y) map to 'farm' — they are variants of the single farm offer and all
 * farm global fields use the 'farm' prefix (farmMegaDownPay, farmTotalPremium, etc.); there are no
 * 'farmHome*'/'farmRental*' global fields. Once Z/Y persist as their own policyType (#31518), a
 * 'farmHome'/'farmRental' mapping would make `${key}MegaDownPay` lookups resolve to undefined in the
 * Bound Policy Segment event (segment.repository.js) and policy-mod preview (preview-policy.event.ts).
 */
export const policyTypeKeys = {
  A: 'auto',
  H: 'home',
  R: 'renters',
  C: 'condo',
  F: 'farm',
  Z: 'farm',
  Y: 'farm'
} as const;
/** Formal insurance product names (lowercase). Note: H maps to 'homeowners' (not 'home') */
export const policyTypeProductNames = {
  A: 'auto',
  H: 'homeowners',
  R: 'renters',
  C: 'condo',
  F: 'farm',
  Z: 'home',
  Y: 'rental'
} as const;
export const policyTypeNames = {
  H: 'Home',
  R: 'Renters',
  C: 'Condo',
  A: 'Auto',
  F: 'Farm',
  Z: 'Home',
  Y: 'Rental',
  AR: 'Auto & renters',
  HA: 'Home & auto',
  CA: 'Condo & auto',
  FA: 'Farm & auto',
  HB: 'Home',
  AB: 'Auto'
};
/**
 * Coverage lines each selectable policy-type option comprises. Single lines map to
 * themselves; bundles to their constituents (HA → H + A). AB/HB are bundled-discount
 * variants of one line (the trailing "B" is not a line). Z/Y (FarmHome/FarmRental)
 * are Farm variants, so they map to ['F'] (mirrors policyTypeKeys). Keyed by raw ids
 * like policyTypeNames/policyTypeLabels above.
 *
 * `satisfies Record<keyof typeof policyTypeNames, ...>` gives compile-time exhaustiveness:
 * a new policy-type id with no entry here (or a typo'd key) is a build error. The export is
 * widened to a string-indexable Record so callers can look up by a runtime string;
 * constants.test.ts also backstops it against policyType at runtime.
 */
const policyTypeLinesByType = {
  H: ['H'],
  A: ['A'],
  R: ['R'],
  C: ['C'],
  F: ['F'],
  HA: ['H', 'A'],
  AR: ['A', 'R'],
  CA: ['C', 'A'],
  FA: ['F', 'A'],
  HB: ['H'],
  AB: ['A'],
  Z: ['F'],
  Y: ['F']
} satisfies Record<keyof typeof policyTypeNames, string[]>;
export const policyTypeLines: Record<string, string[]> = policyTypeLinesByType;
export const rejectionTypeToPolicyTypeMap = {
  auto: [policyType.Auto, policyType.HABundle, policyType.ARBundle],
  home: [policyType.Home, policyType.HABundle],
  renters: [policyType.Renters, policyType.ARBundle],
  condo: [policyType.Condo, policyType.CABundle],
  monoline: [policyType.Auto],
  monolineHome: [policyType.Home],
  monolineCondo: [policyType.Condo],
  farm: [policyType.Farm, policyType.FarmHome, policyType.FarmRental]
};
export const paymentMethod = { CreditCard: 'C', ACH: 'E', Escrow: 'W', BillToOther: 'B', Direct: 'D' };
export const paymentType = { Monthly: 'I', QuarterTerm: 'Q', HalfTerm: 'S', OneTime: 'F', Escrow: 'E' };
export const paymentMode = { Automated: 'A', Direct: 'D' };

export const monitoredStatusThatNeedProof = ['P', 'VP', 'C'];
// must also update branchRequestCancelReasons in docSettings
export const branchInitiatedCancelReasons = ['CNCN', 'CNPP', 'CNPY', 'CNUW', 'CNUV', 'CNUH', 'CNSR', 'CNFP', 'CNSP'];
export const flatCancelReasons = ['CNDP', 'CNMS', 'CNRW'];

export const acceptableCancelCodesForRewrite = ['CNRW'];

// If stormShutters checkbox is wanted to be shown in Advanced Windstorm section, add the state to 'stormShuttersInAdvancedWindstormSectionStates' array too.
export const fortifiedHomeStates = ['AR', 'GA', 'KY'];
export const stormShuttersStates = ['AL', 'MD', 'MS', 'TX', 'SC', 'VA'];
export const stormShuttersInAdvancedWindstormSectionStates = ['SC', 'LA'];
export const stormShuttersVerificationFormLinkStates = {
  SC: 'https://app.getguru.com/card/Txd87yMc/South-Carolina-Mitigation-Verification-Affidavit'
};
export const editableHouseholdMembersStates = ['FL', 'IA', 'KS', 'NM', 'OR', 'SD'];
export const uimAddedOnStates = ['GA'];
export const earthquakeStates = ['KY', 'CA'];

// CFM's Clarion Door Coverage C rate table (factor 21642) has no band between $0 and this value
export const cfmMinimumRateableCoverageC = 5000;

// CFM MO earthquake zones (GitHub issue #32439). This is the single source of truth for both
// the backend brand config (packages/brand-config-be/src/brands/cfm.ts) and the staff-FE mirror
// (staff-fe/src/brand-config/brands/cfm.js); both import this map rather than restating the
// ~160-row regulatory data. Zone 1 = standard / unrestricted (default, not in the map); Zone 2
// = requires underwriter approval before bind (soft rejection); Zone 4 = excluded, EQ cannot be
// offered (enforced at UI + post-data-rules). Zone 3 is intentionally undefined — the ticket's
// underwriting spec only uses 1/2/4.
export enum EarthquakeZone {
  Standard = 1,
  MustApprove = 2,
  Excluded = 4
}

export const earthquakeZonesByZipCfmMO: Record<string, EarthquakeZone> = {
  // Zone 4 — Excluded
  '63662': EarthquakeZone.Excluded,
  '63701': EarthquakeZone.Excluded,
  '63702': EarthquakeZone.Excluded,
  '63703': EarthquakeZone.Excluded,
  '63730': EarthquakeZone.Excluded,
  '63735': EarthquakeZone.Excluded,
  '63736': EarthquakeZone.Excluded,
  '63738': EarthquakeZone.Excluded,
  '63739': EarthquakeZone.Excluded,
  '63740': EarthquakeZone.Excluded,
  '63742': EarthquakeZone.Excluded,
  '63743': EarthquakeZone.Excluded,
  '63744': EarthquakeZone.Excluded,
  '63745': EarthquakeZone.Excluded,
  '63747': EarthquakeZone.Excluded,
  '63750': EarthquakeZone.Excluded,
  '63751': EarthquakeZone.Excluded,
  '63752': EarthquakeZone.Excluded,
  '63753': EarthquakeZone.Excluded,
  '63755': EarthquakeZone.Excluded,
  '63758': EarthquakeZone.Excluded,
  '63760': EarthquakeZone.Excluded,
  '63764': EarthquakeZone.Excluded,
  '63766': EarthquakeZone.Excluded,
  '63767': EarthquakeZone.Excluded,
  '63769': EarthquakeZone.Excluded,
  '63770': EarthquakeZone.Excluded,
  '63771': EarthquakeZone.Excluded,
  '63772': EarthquakeZone.Excluded,
  '63774': EarthquakeZone.Excluded,
  '63779': EarthquakeZone.Excluded,
  '63780': EarthquakeZone.Excluded,
  '63781': EarthquakeZone.Excluded,
  '63782': EarthquakeZone.Excluded,
  '63784': EarthquakeZone.Excluded,
  '63785': EarthquakeZone.Excluded,
  '63787': EarthquakeZone.Excluded,
  '63801': EarthquakeZone.Excluded,
  '63820': EarthquakeZone.Excluded,
  '63821': EarthquakeZone.Excluded,
  '63822': EarthquakeZone.Excluded,
  '63823': EarthquakeZone.Excluded,
  '63824': EarthquakeZone.Excluded,
  '63825': EarthquakeZone.Excluded,
  '63826': EarthquakeZone.Excluded,
  '63827': EarthquakeZone.Excluded,
  '63828': EarthquakeZone.Excluded,
  '63829': EarthquakeZone.Excluded,
  '63830': EarthquakeZone.Excluded,
  '63833': EarthquakeZone.Excluded,
  '63834': EarthquakeZone.Excluded,
  '63837': EarthquakeZone.Excluded,
  '63838': EarthquakeZone.Excluded,
  '63839': EarthquakeZone.Excluded,
  '63840': EarthquakeZone.Excluded,
  '63841': EarthquakeZone.Excluded,
  '63845': EarthquakeZone.Excluded,
  '63846': EarthquakeZone.Excluded,
  '63847': EarthquakeZone.Excluded,
  '63848': EarthquakeZone.Excluded,
  '63849': EarthquakeZone.Excluded,
  '63850': EarthquakeZone.Excluded,
  '63851': EarthquakeZone.Excluded,
  '63852': EarthquakeZone.Excluded,
  '63853': EarthquakeZone.Excluded,
  '63855': EarthquakeZone.Excluded,
  '63857': EarthquakeZone.Excluded,
  '63860': EarthquakeZone.Excluded,
  '63862': EarthquakeZone.Excluded,
  '63863': EarthquakeZone.Excluded,
  '63866': EarthquakeZone.Excluded,
  '63867': EarthquakeZone.Excluded,
  '63868': EarthquakeZone.Excluded,
  '63869': EarthquakeZone.Excluded,
  '63870': EarthquakeZone.Excluded,
  '63871': EarthquakeZone.Excluded,
  '63873': EarthquakeZone.Excluded,
  '63874': EarthquakeZone.Excluded,
  '63875': EarthquakeZone.Excluded,
  '63876': EarthquakeZone.Excluded,
  '63877': EarthquakeZone.Excluded,
  '63878': EarthquakeZone.Excluded,
  '63879': EarthquakeZone.Excluded,
  '63880': EarthquakeZone.Excluded,
  '63881': EarthquakeZone.Excluded,
  '63882': EarthquakeZone.Excluded,
  '63901': EarthquakeZone.Excluded,
  '63902': EarthquakeZone.Excluded,
  '63932': EarthquakeZone.Excluded,
  '63933': EarthquakeZone.Excluded,
  '63936': EarthquakeZone.Excluded,
  '63938': EarthquakeZone.Excluded,
  '63940': EarthquakeZone.Excluded,
  '63945': EarthquakeZone.Excluded,
  '63954': EarthquakeZone.Excluded,
  '63960': EarthquakeZone.Excluded,
  '63961': EarthquakeZone.Excluded,
  '63962': EarthquakeZone.Excluded,
  // Zone 2 — Must Be Approved
  '63036': EarthquakeZone.MustApprove,
  '63087': EarthquakeZone.MustApprove,
  '63601': EarthquakeZone.MustApprove,
  '63620': EarthquakeZone.MustApprove,
  '63621': EarthquakeZone.MustApprove,
  '63623': EarthquakeZone.MustApprove,
  '63624': EarthquakeZone.MustApprove,
  '63625': EarthquakeZone.MustApprove,
  '63626': EarthquakeZone.MustApprove,
  '63627': EarthquakeZone.MustApprove,
  '63628': EarthquakeZone.MustApprove,
  '63629': EarthquakeZone.MustApprove,
  '63632': EarthquakeZone.MustApprove,
  '63633': EarthquakeZone.MustApprove,
  '63636': EarthquakeZone.MustApprove,
  '63637': EarthquakeZone.MustApprove,
  '63638': EarthquakeZone.MustApprove,
  '63640': EarthquakeZone.MustApprove,
  '63645': EarthquakeZone.MustApprove,
  '63646': EarthquakeZone.MustApprove,
  '63650': EarthquakeZone.MustApprove,
  '63651': EarthquakeZone.MustApprove,
  '63653': EarthquakeZone.MustApprove,
  '63654': EarthquakeZone.MustApprove,
  '63655': EarthquakeZone.MustApprove,
  '63656': EarthquakeZone.MustApprove,
  '63661': EarthquakeZone.MustApprove,
  '63663': EarthquakeZone.MustApprove,
  '63665': EarthquakeZone.MustApprove,
  '63666': EarthquakeZone.MustApprove,
  '63670': EarthquakeZone.MustApprove,
  '63673': EarthquakeZone.MustApprove,
  '63675': EarthquakeZone.MustApprove,
  '63732': EarthquakeZone.MustApprove,
  '63737': EarthquakeZone.MustApprove,
  '63746': EarthquakeZone.MustApprove,
  '63748': EarthquakeZone.MustApprove,
  '63763': EarthquakeZone.MustApprove,
  '63775': EarthquakeZone.MustApprove,
  '63776': EarthquakeZone.MustApprove,
  '63783': EarthquakeZone.MustApprove,
  '63931': EarthquakeZone.MustApprove,
  '63934': EarthquakeZone.MustApprove,
  '63935': EarthquakeZone.MustApprove,
  '63937': EarthquakeZone.MustApprove,
  '63939': EarthquakeZone.MustApprove,
  '63941': EarthquakeZone.MustApprove,
  '63942': EarthquakeZone.MustApprove,
  '63943': EarthquakeZone.MustApprove,
  '63944': EarthquakeZone.MustApprove,
  '63947': EarthquakeZone.MustApprove,
  '63950': EarthquakeZone.MustApprove,
  '63951': EarthquakeZone.MustApprove,
  '63952': EarthquakeZone.MustApprove,
  '63953': EarthquakeZone.MustApprove,
  '63955': EarthquakeZone.MustApprove,
  '63956': EarthquakeZone.MustApprove,
  '63957': EarthquakeZone.MustApprove,
  '63963': EarthquakeZone.MustApprove,
  '63964': EarthquakeZone.MustApprove,
  '63965': EarthquakeZone.MustApprove,
  '63966': EarthquakeZone.MustApprove,
  '63967': EarthquakeZone.MustApprove,
  '65439': EarthquakeZone.MustApprove,
  '65566': EarthquakeZone.MustApprove
};
export const palomarErrorPreventPurchasingStates = ['CA'];
export const floodStates = ['TN', 'CA'];
export const nonBranchPlusStates = ['MA', 'AK'];
export const isResidentialOwnerStates = ['FL'];
export const editableResidenceInsuranceType = ['MA'];
export const residenceInsuranceTypes = {
  Home: 'O',
  Manufactured_Mobile: 'M',
  Condo: 'C',
  Renters: 'R',
  None_NotApplicable: 'T'
};

// Maps ZIPs with no ClarionDoor renters territory factor onto a neighboring ZIP
// in the same territory that does, so the auto-bundle rate (which consults the
// renters territory factor for the multi-policy discount) doesn't fail. 97129
// is a valid USPS ZIP for Hillsboro, OR that SmartyStreets normalizes some
// Hillsboro addresses to, but CD has no renters factor for it; 97123 is the
// same Washington County / Hillsboro territory.
export const rentersZipReplacements = {
  '63365': '63383',
  '63380': '63383',
  '63385': '63383',
  '97129': '97123'
};

export const hideHighestEducationStates = ['CA', 'FL', 'GA', 'ID', 'KS', 'MA', 'NY', 'VT'];
/**
 * States whose auto rate plan rates on gender (the Ancestry Review program, #35198), so staff must be
 * able to see and correct it even though the state is in `hideGenderStates`. Staff-only: the direct
 * (quote-fe / account-fe) experience and policy documents keep following `hideGenderStates` until
 * Design decides otherwise. Add a state here when its Ancestry Review filing is approved.
 */
export const genderRatedStates = ['AZ'];
export const hideGenderStates = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
];
export const mustRenewAutoLimit = {
  WV: {
    A: 4,
    H: 4
  }
};
export const equipmentBreakdownServiceLineCoveragesStates = [
  'AR',
  'AZ',
  'DC',
  'GA',
  'IA',
  'IL',
  'IN',
  'KY',
  'LA',
  'MD',
  'MI',
  'MO',
  'MS',
  'MT',
  'ND',
  'NE',
  'NM',
  'OH',
  'OK',
  'OR',
  'PA',
  'TX',
  'UT',
  'WI',
  'WV'
];

// dates EBSL should start in each state
export const EBSLstateDate = {
  AR: '01-20-2022',
  AZ: '01-20-2022',
  DC: '08-29-2022',
  GA: '06-01-2023',
  IA: '01-20-2022',
  IL: '08-30-2022',
  IN: '07-01-2022',
  KY: '08-20-2022',
  LA: '08-20-2022',
  MD: '07-21-2022',
  MI: '07-01-2022',
  MO: '08-13-2022',
  MS: '08-29-2022',
  MT: '01-20-2022',
  ND: '08-29-2022',
  NE: '07-15-2022',
  NM: '08-29-2022',
  OH: '01-20-2022',
  OK: '08-29-2022',
  OR: '08-01-2022',
  PA: '07-01-2022',
  TX: '07-26-2022',
  UT: '08-01-2022',
  WI: '07-01-2022',
  WV: '08-01-2022'
};

// Effective date on/after which Arkansas homeowners can carry the Fortified Roof
// endorsement (FROF / BX H FROF AR 022026), per the 7/1/2026 rate filing. Single source
// of truth for the date gate shared by the rater, docs-engine, and staff UI. KY's FROF is
// not date-gated. See https://github.com/gobranch/branch/issues/30008
export const arFortifiedRoofEndorsementEffectiveDate = '2026-07-01';

// Whether the Fortified Roof Upgrade Endorsement (FROF) is offered for a given state and effective
// date. KY is always supported; AR is gated to effective dates on/after
// arFortifiedRoofEndorsementEffectiveDate (per the 7/1/2026 rate filing). Single source of truth for
// the eligibility predicate shared by the rater, docs-engine, and the customer/staff UIs. Note that
// customer self-service availability (whether a customer may add it themselves) is a separate,
// stricter check (KY-only). See https://github.com/gobranch/branch/issues/29291
export const isFortifiedRoofEndorsementSupported = ({
  state,
  effectiveDate
}: {
  state?: string | null;
  effectiveDate?: string | null;
}): boolean => {
  if (state === 'KY') {
    return true;
  }
  if (state === 'AR' && effectiveDate) {
    const effectiveDateInt = Number(String(effectiveDate).slice(0, 10).replace(/-/g, ''));
    return effectiveDateInt >= Number(arFortifiedRoofEndorsementEffectiveDate.replace(/-/g, ''));
  }
  return false;
};

export const ibscDescriptionByState = {
  LA: 'We recommend 20% Incremental Coverage (Extended Replacement Cost). This way, if it costs more to rebuild your home, you’ll have added peace of mind.',
  MS: 'We recommend 20% Incremental Coverage (Extended Replacement Cost). This way, if it costs more to rebuild your home, you’ll have added peace of mind.',
  SD: 'We recommend 20% Incremental Coverage (Extended Replacement Cost). This way, if it costs more to rebuild your home, you’ll have added peace of mind.'
};

// The front ends show familiar coverage names; Branch's home and condo declarations pages still use these (#37008).
export const policyDocumentCoverageNames = {
  extendedReplacementCost: 'Increased Building Structure Protection',
  ordinanceAndLaw: 'Building Codes',
  personalLiability: 'Family Liability Protection',
  roofSurfacesExtended: 'Roof Surfaces Extended Coverage'
};

export const getPolicyDocumentNameNote = (documentName: string, brandShortName: string) =>
  `Note: This coverage is called ${documentName} on ${brandShortName}'s policy documents.`;

export const driversLicenseRegexByState = {
  AB: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  AK: {
    regex: /^[0-9]{1,7}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 to 7 numbers'
  },
  AL: {
    regex: /^[0-9]{7,10}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 7 to 10 numbers'
  },
  AR: {
    regex: /^\d{9}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers'
  },
  AZ: {
    regex: /^(([a-z][0-9]{8})|([0-9]{9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers or 1 letter + 8 numbers or Social Security number'
  },
  BC: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  CA: {
    regex: /^[a-z]\d{7}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 7 numbers'
  },
  CO: {
    regex: /^\d{9}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers or 1 letter + up to 6 numbers'
  },
  CT: {
    regex: /^\d{9}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers'
  },
  DC: {
    regex: /^(([a-z]{2}\d{8})|(\d{7})|(\d{9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 2 letters + 8 numbers, or 7 numbers, or Social Security number'
  },
  DE: {
    regex: /^[0-9]{1,7}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 to 7 numbers'
  },
  FL: {
    regex: /^[a-z]\d{11,12}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 11-12 numbers'
  },
  GA: {
    regex: /^[0-9]{9}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers'
  },
  HI: {
    regex: /^((\d{9})|([H][0-9]{8}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of letter H + 8 numbers or Social Security number'
  },
  IA: {
    regex: /^((\d{9})|(\d{3}[a-z]{2}\d{4}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers or 9 numbers/letters (4th and 5th characters are letters)'
  },
  ID: {
    regex: /^(([a-z]{2}[0-9]{6}[a-z])|([0-9]{9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 2 letters + 6 numbers + 1 letter or 9 numbers (issued prior to 5/1/93)'
  },
  IL: {
    regex: /^[a-z][0-9]{11}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 11 numbers'
  },
  IN: {
    regex: /^(([a-z]\d{9})|(\d{10}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 10 numbers or 1 letter + 9 numbers'
  },
  KS: {
    regex: /^((\d{9})|([a-z]\d{8})|([a-z0-9]{6}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 6 numbers/letters or 9 numbers or Social Security number or 1 leter + 9 numbers'
  },
  KY: {
    regex: /^(([a-z][0-9]{8})|([0-9]{9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 8 numbers or Social Security number'
  },
  LA: {
    regex: /^[0-9]{9}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers. If less than 9 numbers, fill in with zeros on the front end'
  },
  MA: {
    regex: /^(([a-z]{2}[0-9]{7})|([a-z][0-9]{8})|([0-9]{9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers or 1 letter/number + 8 numbers'
  },
  MB: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  MD: {
    regex: /^(([a-z][0-9]{12})|(md\d{11}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 12 numbers, or "MD" followed by 11 digits'
  },
  ME: {
    regex: /^(\d{7})$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 7 numbers'
  },
  MI: {
    regex: /^[a-z]\d{12}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 12 numbers'
  },
  MN: {
    regex: /^[a-z]\d{12}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 12 numbers'
  },
  MO: {
    regex: new RegExp(
      '^(([a-z][a-z0-9]{5,9})|([0-9]{9,10})|([0-9]{9}[a-z])|([a-z][0-9]{15,16})|([a-z][0-9]{15}[a-z])|([0-9]{3}[a-z][0-9]{6}))$',
      'i'
    ),
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage:
      'Must consist of 9 to 10 numbers or 9 numbers + 1 letter or 1 letter + 15 to 16 numbers or 1 letter + 15 numbers + 1 letter or 1 letter + 5 to 9 letters/numbers or 3 numbers + 1 letter + 6 numbers'
  },
  MS: {
    regex: /^[0-9]{9}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers'
  },
  MT: {
    regex: /^(([a-z0-9]{9})|([a-z0-9]{13}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 13 characters or 9 numbers or 9 letters/numbers'
  },
  NB: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  NC: {
    regex: /^[0-9]{1,12}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 to 12 numbers'
  },
  ND: {
    regex: /^(([a-z]{3}[0-9]{6})|([0-9]{9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 3 letters + 6 numbers or Social Security number'
  },
  NE: {
    regex: /^[a-z][0-9]{3,8}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 3-8 numbers'
  },
  NF: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  NH: {
    regex: /^[a-z0-9]{10,11}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 10-11 letters/numbers'
  },
  NJ: {
    regex: /^[a-z][0-9]{14}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 14 numbers '
  },
  NM: {
    regex: /^[0-9]{8,9}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 8 to 9 numbers '
  },
  NS: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  NT: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  NV: {
    regex: /^(([0-9]{9,10})|([0-9]{12})|(X[0-9]{8})|([0-9]{9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 to 10 numbers or 12 numbers or X + 8 numbers or Social Security number '
  },
  NY: {
    regex: /^(([0-9]{9})|([a-z][0-9]{16,20}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 9 numbers or 1 letter + 16 to 20 numbers or 16 - 20 numbers'
  },
  OH: {
    regex: /^([a-z]{2}[0-9]{6})$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 2 letters + 6 numbers'
  },
  OK: {
    regex: /^([a-z]{1}[0-9]{9})$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 9 numbers'
  },
  ON: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  OR: {
    regex: /^(([0-9]{1,7})|([a-z][0-9]{6})|([a-z]{2}[0-9]{5}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 to 7 numbers or 1 letter + 6 numbers or 2 letters + 5 numbers'
  },
  PA: {
    regex: /^[0-9]{8}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 8 numbers'
  },
  PE: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  PQ: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  RI: {
    regex: /^(([V][0-9]{6})|([0-9]{7}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 7 numbers or V + 6 numbers'
  },
  SC: {
    regex: /^[0-9]{1,10}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 to 10 numbers'
  },
  SD: {
    regex: /^(([0-9]{6})|([0-9]{8,9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 6 or 8 to 9 numbers'
  },
  SK: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  },
  TN: {
    regex: /^[0-9]{8,9}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 8 to 9 numbers'
  },
  TX: {
    regex: /^([0-9]{8}[a-zA-Z]|[0-9]{8})$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 8 numbers'
  },
  UT: {
    regex: /^(([0-9]{4,9})|(0[0-9]{9}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 4 to 9 numbers or 10 numbers (first position must be 0)'
  },
  VA: {
    regex: /^(([a-z][0-9]{8})|([0-9]{9})|([0-9]{12}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 12 numbers or 1 letter + 8 numbers or Social Security number'
  },
  VT: {
    regex: /^[0-9]{7}[A0-9]$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 8 numbers or 7 numbers + A'
  },
  WA: {
    regex: /^[a-z0-9*]{12}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 12 letters/numbers'
  },
  WI: {
    regex: /^[a-z][0-9]{13}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: 'Must consist of 1 letter + 13 numbers'
  },
  WV: {
    regex: /^(([ABCDEFISX][0-9]{6})|([X1][X][0-9]{5})|([a-z][0-9]{6})|([0-9]{7}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage:
      'Must consist of 1 letter + 6 numbers or 2 letters + 5 numbers or 1 letter + 1 number + 5 numbers or 7 numbers'
  },
  WY: {
    regex: /^(([0-9]{9})|([0-9]{6}[-][0-9]{3}))$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: "Must consist of 9 numbers or 6 numbers then a '-' then 3 more numbers"
  },
  YT: {
    regex: /^.{2,16}$/i,
    commonErrorMessage: 'Driver License Number is not valid.',
    errorMessage: ''
  }
};

export const allowedDirectMonolineCurrentCarriers = [
  '00109', // Everspan
  '00128',
  '00182',
  '00270',
  '00273',
  '00277',
  '00349',
  '00366',
  '00391',
  '00460',
  '00466',
  '00542',
  '00548',
  '00586',
  '00588',
  '00601',
  '00603',
  '00609',
  '00638',
  '00643',
  '00649',
  '00662',
  '00671',
  '00712',
  '00762',
  '00764',
  '00934',
  '00956',
  '01737',
  '01743',
  '01744',
  '01762',
  '01767',
  '01812',
  '01839',
  '01852',
  '01853',
  '01864',
  '01873',
  '01891',
  '01896',
  '01900',
  '01921',
  '01978',
  '01987',
  '01996',
  '02001',
  '02002',
  '02016',
  '02017',
  '02018',
  '02022',
  '02023',
  '02028',
  '02084',
  '02085',
  '02086',
  '02088',
  '02147',
  '02159',
  '02171',
  '02172',
  '02173',
  '02174',
  '02204',
  '02205',
  '02229',
  '02230',
  '02231',
  '02232',
  '02234',
  '02235',
  '02253',
  '02254',
  '02276',
  '02282',
  '02283',
  '02286',
  '02287',
  '02289',
  '02290',
  '02356',
  '02357',
  '02358',
  '02360',
  '02361',
  '02363',
  '02378',
  '02379',
  '02385',
  '02386',
  '02389',
  '02393',
  '02394',
  '02407',
  '02408',
  '02446',
  '02447',
  '02448',
  '02452',
  '02453',
  '02476',
  '02477',
  '02478',
  '02479',
  '02483',
  '02496',
  '02513',
  '02516',
  '02517',
  '02518',
  '02520',
  '02523',
  '02526',
  '02538',
  '02550',
  '02577',
  '02594',
  '02609',
  '02610',
  '02611',
  '02612',
  '02613',
  '02614',
  '02634',
  '02640',
  '02650',
  '02665', // GSNIC
  '02701',
  '02709',
  '02761',
  '02784',
  '02855',
  '02866',
  '03028',
  '03045',
  '03100',
  '03132',
  '03288',
  '03289',
  '03292',
  '03299',
  '03312',
  '03539',
  '03566',
  '03596',
  '03645',
  '03652',
  '03690',
  '03733',
  '03756',
  '03779',
  '03791',
  '03792',
  '03794',
  '03795',
  '03831',
  '04003',
  '04025',
  '04046',
  '04049',
  '04083',
  '04097',
  '04158',
  '04159',
  '04240',
  '04274',
  '04287',
  '04305',
  '04306',
  '04311',
  '04456',
  '04461',
  '04465',
  '04675',
  '04785',
  '04865',
  '04869',
  '04938',
  '04976',
  '06627',
  '10106',
  '10130',
  '10346',
  '10419',
  '10648',
  '10678',
  '10709',
  '10724',
  '10745',
  '10764',
  '10765',
  '10777',
  '10852',
  '11020',
  '11024',
  '11025',
  '11026',
  '11027',
  '11055',
  '11087',
  '11088',
  '11150',
  '11224',
  '11241',
  '11244',
  '11246',
  '11247',
  '11248',
  '11300',
  '11302',
  '11325',
  '11354',
  '11417',
  '11421',
  '11441',
  '11578',
  '11654',
  '11665',
  '11688',
  '11689',
  '11698',
  '11699',
  '11702',
  '11703',
  '11758',
  '11759',
  '11760',
  '11761',
  '11762',
  '11778',
  '11779',
  '11780',
  '11789',
  '11790',
  '11794',
  '11802',
  '11872',
  '11946',
  '11979',
  '12051',
  '12053',
  '12058',
  '12059',
  '12078',
  '12089',
  '12106',
  '12120',
  '12121',
  '12128',
  '12150',
  '12163',
  '12212',
  '12213',
  '12238',
  '12410',
  '12421',
  '12425',
  '12460',
  '12535',
  '12536',
  '12560',
  '12561',
  '12563',
  '12569',
  '12612',
  '12710',
  '12711',
  '13016',
  '13080',
  '13082',
  '13083',
  '13107',
  '13866',
  '13878',
  '13917',
  '14235',
  '14301',
  '14302',
  '14303',
  '18538',
  '22001',
  '22059',
  '22601',
  '23178',
  '66716', // BIX
  '86485'
];

export const nodePathToFriendlyName = {
  'homeCoverage.coverageA': 'Replacement Cost',
  'homeCoverage.coverageIBSC': 'Extended Replacement Cost Coverage Limit',
  'homeCoverage.coverageBCPctOfA': 'Ordinance and Law Coverage Limit',
  'homeCoverage.coverageBPctOfA': 'Other Structures Coverage Limit',
  'homeCoverage.coverageCPctOfA': 'Personal Property Coverage Limit',
  'homeCoverage.coverageDPctOfA': 'Additional Living Expenses Coverage Limit',
  'homeCoverage.coverageX': 'Personal Liability Coverage Limit',
  'homeCoverage.coverageY': 'Guest Medical Coverage Limit',
  'homeCoverage.coverageBP': 'Additional Coverage on Business Property Limit',
  'homeCoverage.coverageCA': 'Additional Coverage on Camera Property Limit',
  'homeCoverage.coverageDR': 'Electronic Data Recovery Coverage',
  'homeCoverage.coverageF': 'Limit on Fire Department Charges',
  'homeCoverage.coverageG': 'Loss Assessments Limit',
  'homeCoverage.coverageJ': 'Additional Coverage on Jewelry, Watches, and Furs Limit',
  'homeCoverage.coverageMI': 'Additional Coverage on Musical Instruments Limit',
  'homeCoverage.coverageMS': 'Mine Subsidence Coverage',
  'homeCoverage.coverageMSALE': 'Mine Subsidence ALE Coverage',
  'homeCoverage.coverageSP': 'Additional Coverage on Sports Equipment Limit',
  'homeCoverage.coverageST': 'Additional Coverage on Silverware Theft Limit',
  'autoCoverage.policyLimitPIPME': 'PIP Medical Limit',
  'auto.pipEveryoneOnSamePlan': 'PIP - All Residents on Same Health Plan',
  'auto.pipHealthInsuranceType': 'PIP - Health Insurance Type',
  'auto.pipAdditionalResidents': 'PIP - Additional Household Residents',
  'auto.pipResidentsWithQHC': 'PIP - Residents With Qualified Health Coverage',
  'auto.pipExcludedResidents': 'PIP - Excluded Residents',
  'auto.pipAllResidents': 'PIP - All Household Residents',
  includeUmbrella: 'Umbrella coverage',
  'umbrellaCoverage.liabilityCoverageLimit': 'Umbrella liability limit',
  'umbrellaCoverage.uninsuredMotoristLimit': 'UM/Underinsured motorist BI (umbrella)',
  'umbrellaCoverage.highRisk': 'High risk coverage (umbrella)',
  'umbrellaCoverage.presenceOfBusiness': 'Business at home (umbrella)',
  'umbrellaCoverage.numVehiclesTotal': 'Number of cars (umbrella)',
  'umbrellaCoverage.numLicensedDriversUnder25': 'Number of licensed drivers under 25 (umbrella)',
  'umbrellaCoverage.numMotorcyclesScooters': 'Number of motorcycles & scooters (umbrella)',
  'umbrellaCoverage.numRVs': 'Number of golf carts & snowmobiles (umbrella)',
  'umbrellaCoverage.numATVs': 'Number of ATVs (umbrella)',
  'umbrellaCoverage.numPersonalWatercraft': 'Number of personal watercraft & jet skis (umbrella)',
  'umbrellaCoverage.numWatercraft': 'Number of boats (umbrella)',
  'umbrellaCoverage.watercraftHullLengths': 'Boats (umbrella)',
  'umbrellaCoverage.rentalPropertyAddresses': 'Rental properties (umbrella)',
  'umbrellaCoverage.numRentalProperties': 'Number of rental properties (umbrella)',
  'umbrellaCoverage.otherPropertyAddresses': 'Additional residences (umbrella)',
  'umbrellaCoverage.numOtherProperties': 'Number of additional residences (umbrella)',
  removedDrivers: 'Non-rated individuals'
};

export const statesThatRequireSignedUMNotice = [
  'AL',
  'AR',
  'AZ',
  'DC',
  'GA',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MO',
  'MS',
  'MT',
  'ND',
  'NE',
  'NH',
  'NM',
  'OH',
  'OK',
  'OR',
  'PA',
  'SC',
  'SD',
  'TN',
  'UT',
  'VA',
  'VT',
  'WI',
  'WV',
  'WY'
];

export const statesThatRequireSignedUMPDNotice = ['AR', 'DC', 'GA', 'ID', 'IN', 'MD', 'RI', 'TN', 'TX', 'VA'];

export const seniorAge = {
  MA: 65
};

export const inexperiencedYearsLimit = {
  MA: 7
};

export const deletedDriversReasons = {
  PRIOR_OWNER: 'PRIOR_OWNER',
  NON_RELATIVE: 'NON_RELATIVE',
  NON_LICENSED: 'NON_LICENSED',
  MILITARY_AWAY: 'MILITARY_AWAY',
  RESIDENT_RELATIVE_OWN_INS: 'RESIDENT_RELATIVE_OWN_INS',
  DECEASED: 'DECEASED'
};

export const nonRenewalNotificationByState = {
  AL: {
    A: 20,
    H: 30
  },
  AK: {
    A: 20,
    H: 20
  },
  AZ: {
    A: 45,
    H: 30
  },
  AR: {
    A: 30,
    H: 30
  },
  CA: {
    A: 75,
    H: 75
  },
  CO: {
    A: 30,
    H: 60
  },
  CT: {
    A: 60,
    H: 60
  },
  DE: {
    A: 20,
    H: 30
  },
  DC: {
    A: 30,
    H: 30
  },
  FL: {
    A: 45,
    H: 120
  },
  GA: {
    A: 30,
    H: 60
  },
  HI: {
    A: 30,
    H: 30
  },
  ID: {
    A: 30,
    H: 30
  },
  IL: {
    A: 30,
    H: 30
  },
  IN: {
    A: 20,
    H: 20
  },
  IA: {
    A: 60,
    H: 60
  },
  KS: {
    A: 30,
    H: 30
  },
  KY: {
    A: 75,
    H: 75
  },
  LA: {
    A: 20,
    H: 30
  },
  ME: {
    A: 30,
    H: 30
  },
  MD: {
    A: 45,
    H: 45
  },
  MA: {
    A: 45,
    H: 45
  },
  MI: {
    A: 30,
    H: 30
  },
  MN: {
    A: 60,
    H: 60
  },
  MS: {
    A: 30,
    H: 30
  },
  MO: {
    A: 30,
    H: 30
  },
  MT: {
    A: 45,
    H: 45
  },
  NE: {
    A: 20,
    H: 60
  },
  NV: {
    A: 30,
    H: 30
  },
  NH: {
    A: 45,
    H: 45
  },
  NJ: {
    A: 60,
    H: 30
  },
  NM: {
    A: 30,
    H: 30
  },
  NY: {
    A: 45,
    H: 45
  },
  NC: {
    A: 60,
    H: 30
  },
  ND: {
    A: 30,
    H: 45
  },
  OH: {
    A: 30,
    H: 30
  },
  OK: {
    A: 20,
    // #34853 — OK statute raised home non-renewal notice window 30→60 (already in effect)
    H: 60
  },
  OR: {
    A: 30,
    H: 30
  },
  PA: {
    A: 60,
    H: 30
  },
  RI: {
    A: 30,
    H: 30
  },
  SC: {
    A: 15,
    H: 60
  },
  SD: {
    A: 60,
    H: 30
  },
  TN: {
    A: 30,
    H: 30
  },
  TX: {
    A: 60,
    H: 60
  },
  UT: {
    A: 30,
    H: 30
  },
  VT: {
    A: 45,
    H: 45
  },
  VA: {
    A: 45,
    H: 30
  },
  WA: {
    A: 20,
    H: 45
  },
  WV: {
    A: 45,
    H: 30
  },
  WI: {
    A: 60,
    H: 60
  },
  WY: {
    A: 30,
    H: 45
  }
};

/**
 * Returns the non-renewal notification days for a given state, policy type, and policy end date.
 * Handles date-effective regulatory changes and IL's tenure rule (5+ years in force at the end date
 * needs 60 days, 215 ILCS 5/143.17 home / 143.17a auto). The statute's 30-day carve-outs (nonpayment,
 * fraud, license status) are only reachable as cancellations here, so non-renewals don't check reason.
 * GitHub: https://github.com/gobranch/branch/issues/29738 (MS),
 *         https://github.com/gobranch/branch/issues/31312 (IN),
 *         https://github.com/gobranch/branch/issues/31311 (LA),
 *         https://github.com/gobranch/branch/issues/31270 (IL),
 *         https://github.com/gobranch/branch/issues/36669 (IL home)
 */
export function getNonRenewalNotificationDays(
  state: string,
  policyType: string,
  endDate?: string,
  { policyInceptionDate }: { policyInceptionDate?: string } = {}
): number {
  const baseDays =
    nonRenewalNotificationByState[state as keyof typeof nonRenewalNotificationByState]?.[policyType as 'A' | 'H'];
  if (!baseDays) {
    throw new Error(`No non-renewal notification config for state: ${state}, policyType: ${policyType}`);
  }

  if (state === 'IL' && endDate && policyInceptionDate) {
    // both are YYYY-MM-DD, so a string compare orders them
    const fiveYearsBeforeEndDate = `${Number(endDate.slice(0, 4)) - 5}${endDate.slice(4)}`;
    if (policyInceptionDate <= fiveYearsBeforeEndDate) {
      return 60;
    }
  }

  // New IL legislation: home non-renewal notice rises 30→60 for terms ending on or after 12/31/2026 (#36669).
  // Auto keeps the base 30 (and the 5-year tenure rule above).
  if (state === 'IL' && policyType === 'H' && endDate && endDate >= '2026-12-31') {
    return 60;
  }

  // Effective 7/1/2026, non-renewal notice window increases from 30 to 45 days
  if (state === 'MS' && endDate && endDate >= '2026-07-01') {
    return 45;
  }

  // HB1260 (enacted 2026-03-04): effective 7/1/2026, IN non-renewal notice rises — auto 20→30, home 20→60
  if (state === 'IN' && endDate && endDate >= '2026-07-01') {
    return policyType === 'H' ? 60 : 30;
  }

  // Act 182 of 2025 (HB345): effective 7/1/2026, LA non-renewal notice rises to 60 days (auto and home)
  if (state === 'LA' && endDate && endDate >= '2026-07-01') {
    return 60;
  }

  return baseDays;
}

export const everspanAndSCORStatesMapToPolicyType = {
  VT: ['A', 'H'],
  NH: ['A', 'H'],
  MA: ['A', 'H'],
  KS: ['A', 'H'],
  WY: ['A', 'H'],
  AL: ['A', 'H'],
  ID: ['H'],
  VA: ['A', 'H'],
  SC: ['A', 'H'],
  SD: ['A', 'H'],
  TN: ['A', 'H'],
  CO: ['A', 'H']
};

export const cancelCodeInformationalArray = [
  {
    cancelCode: 'CNDC',
    cancelReasonPlainText: 'Member Dissatisfied with Claims',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNPR',
    cancelReasonPlainText: 'Member Dissatisfied with Price',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNDR',
    cancelReasonPlainText: 'Member Dissatisfied with Roadside',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Dissatisfied with Roadside'
  },
  {
    cancelCode: 'CNDB',
    cancelReasonPlainText: 'Member Dissatisfied with Service',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNDA',
    cancelReasonPlainText: 'Member Dissatisfied with Agency',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNMS',
    cancelReasonPlainText: 'Member Misrepresentation',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Misrepresentation'
  },
  {
    cancelCode: 'CNPY',
    cancelReasonPlainText: 'Member Non-Payment',
    // ODEN (triggered by insurer)
    cancelNoticeName: 'CNPY',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date]',
    boxTwoText: 'Reason(s) for Cancellation: Non-Payment'
  },
  {
    cancelCode: 'CNPY_X',
    cancelReasonPlainText: 'Non-Payment of Premium (Exception)',
    // CD (triggered by customer request)
    cancelNoticeName: 'CNPY',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date]',
    boxTwoText: 'Reason(s) for Cancellation: Non-Payment'
  },
  {
    cancelCode: 'CNID',
    cancelReasonPlainText: 'Documents Not Signed',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Documents Not Signed'
  },
  {
    cancelCode: 'CNCN',
    cancelReasonPlainText: 'Ineligible Condition of Home',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Ineligible Condition of Home',
    allowFreeFormNote: true
  },
  {
    cancelCode: 'CNMV',
    cancelReasonPlainText: 'Moving, Eligible with Carrier',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNMI',
    cancelReasonPlainText: 'Moving, No Longer Eligible with Carrier',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNNO',
    cancelReasonPlainText: 'Other Customer Cancellation',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNUW',
    cancelReasonPlainText: 'Other Underwriting',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Underwriting; No Insurable Interest'
  },
  {
    cancelCode: 'CNSO',
    cancelReasonPlainText: "Sold the Insured Property/Didn't Purchase",
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNDP',
    cancelReasonPlainText: 'Duplicate Policy',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Duplicate Policy'
  },
  {
    cancelCode: 'CNIP',
    cancelReasonPlainText: 'Invalid Policy',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Invalid Policy'
  },
  {
    cancelCode: 'CNPP',
    cancelReasonPlainText: 'No Proof of Prior',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: No Proof of Prior Insurance'
  },
  {
    cancelCode: 'CNAP',
    cancelReasonPlainText: 'Accidental Purchase',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNBX',
    cancelReasonPlainText: 'Member Convert to Bix',
    // no cancellation docs generated for CNBX
    cancelNoticeName: '',
    boxOneText: '',
    boxTwoText: ''
  },
  {
    cancelCode: 'CNFP',
    cancelReasonPlainText: 'Failure to provide underwriting information',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date]',
    boxTwoText: 'Reason(s) for Cancellation: Failure to provide underwriting information'
  },
  {
    cancelCode: 'CNNR',
    cancelReasonPlainText: 'Non-renewal',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: [fill in]',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'NRAT',
    cancelReasonPlainText: 'Agency Termination',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: Agent/agency no longer represents the company',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'NREV',
    cancelReasonPlainText: 'Everspan Non-renewal',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText:
      'Reason(s) for Non-Renewal: Everspan Insurance Company is no longer offering insurance policies through Branch in your state due to a loss of reinsurance',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'NRSC',
    cancelReasonPlainText: 'GSNIC Non-renewal',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText:
      'Reason(s) for Non-Renewal: The insurer, General Security National Insurance Company, has decided to stop offering personal lines insurance policies in your state.',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'CNDE',
    cancelReasonPlainText: 'Member Deceased',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNAG',
    cancelReasonPlainText: 'Agency Book Roll',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Previous Agency Policy'
  },
  {
    cancelCode: 'CNBN',
    cancelReasonPlainText: 'BIX Forced Non-Renewal',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText:
      'Reason(s) for Non-Renewal: General Security National Insurance Company is no longer offering policies in your state. ',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'CNDY',
    cancelReasonPlainText: 'Bix Opt out',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Opt Out of BIX Policy '
  },
  {
    cancelCode: 'NRUW',
    cancelReasonPlainText: 'Non-Renewal For Underwriting Reasons',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: [Fill In]',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'CNUV',
    cancelReasonPlainText: 'Underwriting: Ineligible Vehicle',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Underwriting; Ineligible Vehicle'
  },
  {
    cancelCode: 'CNUH',
    cancelReasonPlainText: 'Underwriting: Ineligible Driving History',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Underwriting; Ineligible Driving History'
  },
  {
    cancelCode: 'CNRW',
    cancelReasonPlainText: 'Policy Rewrite',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Named Insured Request'
  },
  {
    cancelCode: 'CNSR',
    cancelReasonPlainText: 'Underwriting: Substantial Change in Risk',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Cancellation: Underwriting: Substantial Change in Risk'
  },
  {
    cancelCode: 'NCAT',
    cancelReasonPlainText: 'Reinsurance Capacity',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: Catastrophe Risk Exposure Management',
    nonRenew: true,
    allowFreeFormNote: true
  },
  // NACP is currently only for AZ Auto policies
  {
    cancelCode: 'NACP',
    cancelReasonPlainText: 'Policy Not Accepted',
    // No cancellation docs will be generated for NACP
    cancelNoticeName: '',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
    boxTwoText: 'Policy Not Accepted'
  },
  {
    cancelCode: 'NRLV',
    cancelReasonPlainText: 'Underwriting Reasons - Loss and/or violation activity',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: Underwriting Reasons - Loss and/or violation activity',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'NRLS',
    cancelReasonPlainText: 'Underwriting Reasons - Invalid license status',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: Underwriting Reasons - Invalid license status',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'NRFP',
    cancelReasonPlainText: 'Underwriting Reasons - Failure to provide underwriting information',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: Underwriting Reasons - Failure to provide underwriting information',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'NRCH',
    cancelReasonPlainText: 'Underwriting Reasons - Property condition and/or hazard concerns',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: Underwriting Reasons - Property condition and/or hazard concerns',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'NRPC',
    cancelReasonPlainText: 'Underwriting Reasons - Property claims activity',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: Underwriting Reasons - Property claims activity',
    nonRenew: true,
    allowFreeFormNote: true
  },
  {
    cancelCode: 'CNSP',
    cancelReasonPlainText: 'Failure to Comply with Inspection Requirements',
    cancelNoticeName: 'CNRS',
    boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date]',
    boxTwoText: 'Reason(s) for Cancellation: Failure to comply with inspection requirements'
  },
  {
    cancelCode: 'NNSP',
    cancelReasonPlainText: 'Failure to Comply with Inspection Requirements',
    cancelNoticeName: 'NRRS',
    boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
    boxTwoText: 'Reason(s) for Non-Renewal: Failure to Comply with Inspection Requirements',
    nonRenew: true,
    allowFreeFormNote: true
  }
];

export const AssurityPaymentTypes = {
  BankAccount: 'BankAccount',
  CreditCard: 'CreditCard'
};

export const defaultRenewalBillingDayStates = { PA: true, MD: true };
export const daysBeforeEffectiveDateForRenewalBilling = {
  [paymentMethod.CreditCard]: 5,
  [paymentMethod.ACH]: 7
};

export const requireDriversLicenseNumberBeforePullingMVRStates = ['KY', 'MI', 'MT', 'NE', 'NM'];

export const URPActionDays = {
  AL: {
    A: 60,
    H: 60
  },
  AK: {
    A: 60,
    H: 30
  },
  AZ: {
    A: 60,
    H: 60
  },
  AR: {
    A: 60,
    H: 60
  },
  CA: {
    A: null,
    H: 60
  },
  CO: {
    A: 60,
    H: 30
  },
  CT: {
    A: 60,
    H: 60
  },
  DE: {
    A: 60,
    H: 60
  },
  DC: {
    A: 60,
    H: 30
  },
  FL: {
    A: 60,
    H: 90
  },
  GA: {
    A: 60,
    H: 60
  },
  HI: {
    A: 60,
    H: 60
  },
  ID: {
    A: 60,
    H: 60
  },
  IL: {
    A: 60,
    H: 60
  },
  IN: {
    A: 60,
    H: 60
  },
  IA: {
    A: 60,
    H: 60
  },
  KS: {
    A: 60,
    H: 60
  },
  KY: {
    A: 60,
    H: 60
  },
  LA: {
    A: 60,
    H: 60
  },
  ME: {
    A: 60,
    H: 90
  },
  MD: {
    A: 45,
    H: 45
  },
  MA: {
    A: 90,
    H: 60
  },
  MI: {
    A: 55,
    H: 55
  },
  MN: {
    A: 60,
    H: 60
  },
  MS: {
    A: 60,
    H: 60
  },
  MO: {
    A: 60,
    H: 60
  },
  MT: {
    A: 60,
    H: 60
  },
  NE: {
    A: 60,
    H: 60
  },
  NV: {
    A: 70,
    H: 70
  },
  NH: {
    A: 60,
    H: 90
  },
  NJ: {
    A: 60,
    H: 60
  },
  NM: {
    A: 60,
    H: 60
  },
  NY: {
    A: 60,
    H: 60
  },
  NC: {
    A: null,
    H: 60
  },
  ND: {
    A: 60,
    H: 60
  },
  OH: {
    A: 90,
    H: 60
  },
  OK: {
    A: 60,
    H: 45
  },
  OR: {
    A: 60,
    H: 60
  },
  PA: {
    A: 60,
    H: 60
  },
  RI: {
    A: 60,
    H: 60
  },
  SC: {
    A: 90,
    H: 120
  },
  SD: {
    A: 60,
    H: 60
  },
  TN: {
    A: 60,
    H: 60
  },
  TX: {
    A: 60,
    H: 60
  },
  UT: {
    A: 60,
    H: 60
  },
  VT: {
    A: 60,
    H: 60
  },
  VA: {
    A: 60,
    H: 90
  },
  WA: {
    A: 60,
    H: 60
  },
  WV: {
    A: 60,
    H: 60
  },
  WI: {
    A: 60,
    H: 60
  },
  WY: {
    A: 60,
    H: 60
  }
};

// Farm policy types (F = Farm, Z = FarmHome, Y = FarmRental) are not subject to an
// Underwriting Review Period. Setting them to null in every state — rather than
// leaving them absent — makes isWithinURPWindow() return false quietly instead of
// logging "Unsupported policy type '<F/Z/Y>' for state '<state>' in URP calculation"
// on every farm policy endorsement (see packages/policy-utils/src/lib/urp-utils.ts).
// Condo (C) and renters (R) have no URP entry either, so they get the same null.
// That keeps today's behavior (no URP) and stops the staff policy header logging
// that error on every first-term condo/renters policy view. (#34196)
for (const stateConfig of Object.values(URPActionDays)) {
  Object.assign(stateConfig, { F: null, Z: null, Y: null, C: null, R: null });
}

// When the renewals cron generates a renewal, in days before the current term's endDate:
// `first` is the first day the policy is picked up, `last` is the last day a failed renewal is retried.
// Copied from the eligibility windows in the dbt model that feeds the cron:
// gobranch/data-dbt models/automation/dev/cached_4x_daily/automation_renewals.sql
// That model is the source of truth. Change both together. (#34196)
// Auto is keyed policyType.Auto; home, condo and renters share policyType.Home. States not listed use DEFAULT.
// Farm renews through a different flow.
const renewalGenerationDays = (autoFirst: number, homeFirst: number, last = 3) => ({
  [policyType.Auto]: { first: autoFirst, last },
  [policyType.Home]: { first: homeFirst, last }
});
export const renewalGenerationDaysBeforeEndDate = {
  DEFAULT: renewalGenerationDays(38, 43),
  AR: renewalGenerationDays(39, 44),
  AZ: renewalGenerationDays(43, 43),
  DC: renewalGenerationDays(43, 43),
  IA: renewalGenerationDays(59, 59),
  KY: renewalGenerationDays(80, 80, 45),
  MD: renewalGenerationDays(48, 48),
  MT: renewalGenerationDays(43, 43),
  OK: renewalGenerationDays(43, 43),
  OR: renewalGenerationDays(43, 43),
  WI: renewalGenerationDays(43, 43)
};

// In these states the renewals cron only renews BIX-paper policies (same dbt model).
// Same states as originalGSNICStates today, but copied from the dbt model on purpose, not derived:
// dbt is the source of truth, so this list follows it if the two ever differ.
export const renewalGenerationBixOnlyStates = ['AZ', 'MO', 'OH', 'TX', 'IL'];

// Carrier exits: the renewals cron never renews a policy in these states whose endDate is on or after
// `endDateOnOrAfter`, whatever its paper. `policyTypes` limits a block to those exact types (CO and AL
// home blocks do not cover condo or renters); without it the whole state is blocked. Same dbt model.
export const renewalGenerationBlocks = [
  { states: ['MA', 'NH', 'SD', 'TN', 'VT', 'WY'], endDateOnOrAfter: '2023-09-30' }, // Everspan
  { states: ['KS', 'SC', 'VA'], endDateOnOrAfter: '2023-12-31' }, // GSNIC
  { states: ['CO'], policyTypes: [policyType.Auto, policyType.Home], endDateOnOrAfter: '2023-12-31' },
  { states: ['AL'], policyTypes: [policyType.Home], endDateOnOrAfter: '2023-02-28' },
  { states: ['AL'], policyTypes: [policyType.Auto], endDateOnOrAfter: '2023-12-31' },
  { states: ['ID'], endDateOnOrAfter: '2024-01-25' }
];

/**
 * Regular expressions for detecting PO Box addresses
 * Used for address validation across frontend and backend
 */
export const poBoxPatterns = [
  /^\s*(?:Post(?:al)?\s*(?:Office\s*)?|P[.\s]?O\.?\s*)?Box\b/i,
  /\b[p]+(ost)*\.*\s*[o|0]*(ffice)*\.*\s*b[o|0]x\b/i
];

// States using a 3-year (36-month) lookback for homeowners new business loss history
// eligibility. Used by the UW rules engine to pick the 3-year rule path, and by
// surfaces that explain the rejection to applicants/agents (e.g. error copy that
// otherwise references the default 5-year window). GitHub #30832.
export const threeYearLossHistoryStates: Record<string, boolean> = {
  AZ: true,
  AR: true,
  DC: true,
  GA: true,
  IL: true,
  IN: true,
  IA: true,
  MD: true,
  MO: true,
  MT: true,
  NE: true,
  NM: true,
  ND: true,
  OH: true,
  OK: true,
  UT: true,
  WV: true,
  WI: true
};

/**
 * States adopting the expanded home underwriting guidelines on a future rate-change date rather
 * than immediately. On/after `startDate` (compared against the policy's homeEffectiveDate) the
 * state relaxes its home-age cap to `maxHomeAge` years AND moves onto the standard 3-year tiered
 * loss-history rules (see threeYearLossHistoryStates / checkHomeClaimsForThreeYearStates); before
 * that date it keeps today's behavior. MS #33921 (live 2026-10-16), PA #33920 (live 2026-10-22).
 * Both guideline changes flip together, tied to each state's planned rate change.
 *
 * MS originally shipped as 2026-09-16 (#34107) and was pushed back a month to 2026-10-16 when the
 * MS rate change moved. These dates track each state's rate change, so move them together.
 */
export const homeGuidelineExpansionByState: Record<string, { startDate: string; maxHomeAge: number }> = {
  MS: { startDate: '2026-10-16', maxHomeAge: 50 },
  PA: { startDate: '2026-10-22', maxHomeAge: 50 }
};

/**
 * States where a SECONDARY home/condo (ownershipStatus 'S') is held to a stricter loss-history
 * allowance than a primary residence: for new business, a single water, theft, liability, or
 * vandalism loss in the trailing 3 years makes the secondary ineligible (GitHub #32689).
 *
 * This is the same list as threeYearLossHistoryStates EXCEPT Maryland — MD regulations require
 * secondary homes be treated the same as they are today, so MD is intentionally omitted. Oklahoma
 * is included even though it has its own dedicated loss-history method.
 */
export const secondaryHomeStrictLossHistoryStates: Record<string, boolean> = {
  AZ: true,
  AR: true,
  DC: true,
  IL: true,
  IN: true,
  IA: true,
  MO: true,
  MT: true,
  NE: true,
  NM: true,
  ND: true,
  OH: true,
  OK: true,
  UT: true,
  WV: true,
  WI: true
};

// States that legally require auto comprehensive coverage to carry a $0 glass deductible,
// represented by the "/0GL" composite deductible id (e.g. "1000/0GL"). GitHub #31808.
export const zeroGlassDeductibleStates = ['KY'];

// KY only offers glass variants; excluding it strips every real comprehensive option (#33354).
export const comprehensiveGlassDeductibleStates = ['AZ', 'MA', ...zeroGlassDeductibleStates];

/**
 * Normalizes a comprehensive deductible for states that require $0 glass coverage.
 * Appends "/0GL" to a plain numeric comprehensive deductible (e.g. "1000" -> "1000/0GL") so the
 * offer is compliant. Leaves "NONE" (no coverage), "0" ($0 deductible already implies $0 glass),
 * and any value already carrying a glass extension untouched. No-op for other states. GitHub #31808.
 */
export function coerceComprehensiveGlassDeductible({
  deductibleComprehensive,
  state
}: {
  deductibleComprehensive?: string | null;
  state?: string;
}): string | null | undefined {
  if (!deductibleComprehensive || !state || !zeroGlassDeductibleStates.includes(state)) {
    return deductibleComprehensive;
  }
  const value = String(deductibleComprehensive);
  if (value === 'NONE' || value === '0') {
    return deductibleComprehensive;
  }
  if (value.includes('/')) {
    return deductibleComprehensive; // already has a glass extension
  }
  return `${value}/0GL`;
}

// States that express PIP as a composite "<limit>/<deductible>DED" id (e.g. "10000/500DED"); their
// policyLimitPIP lookup has no bare-limit entry. Kept as a list so the same treatment can extend to
// another state without touching call sites. GitHub #35289.
export const pipLimitDeductibleStates = ['KY'];

// Default PIP deductible applied when a caller submits a bare limit for one of the states above.
// Product decision (#35289): coerce an unspecified KY PIP deductible to $500 ("500DED").
export const defaultPipLimitDeductibleSuffix = '500DED';

/**
 * Normalizes a PIP limit for states whose PIP carries a deductible dimension (KY). Comparative
 * raters and partner/agency submissions frequently send a bare limit ("10000"), which has no
 * matching ClarionDoor factor and 4001s the whole quote ("Unable to locate factors for factor id
 * [4289] ... [PIP_limit_where] => 10000"). Append the default deductible suffix so the value rates
 * (e.g. "10000" -> "10000/500DED"). Leaves "NONE"/"0" (no coverage), values that already carry a
 * suffix, and non-numeric limits (e.g. AR income-disability codes) untouched. No-op for other
 * states. Mirrors coerceComprehensiveGlassDeductible. GitHub #35289.
 */
export function coercePipLimitDeductible({
  policyLimitPIP,
  state
}: {
  policyLimitPIP?: string | number | null;
  state?: string;
}): string | number | null | undefined {
  if (policyLimitPIP == null || !state || !pipLimitDeductibleStates.includes(state)) {
    return policyLimitPIP;
  }
  const value = String(policyLimitPIP);
  if (value === 'NONE' || value === '0' || value.includes('/') || !/^\d+$/.test(value)) {
    return policyLimitPIP;
  }
  return `${value}/${defaultPipLimitDeductibleSuffix}`;
}

// Customer quote and endorsement controls. Distinct from doNotShowCarLevelUMPDStates:
// WI/OK remain excluded here pending the UMPD authority decision.
export const customerCarLevelUMPDStates: Record<string, { showExpandedOptions: boolean }> = {
  CO: { showExpandedOptions: true },
  ID: { showExpandedOptions: false },
  LA: { showExpandedOptions: false },
  NM: { showExpandedOptions: false },
  OH: { showExpandedOptions: false },
  OR: { showExpandedOptions: false },
  IL: { showExpandedOptions: false },
  UT: { showExpandedOptions: false }
};

// VA reviews income loss per car; incomeLossStates also includes policy-level states.
export const carLevelIncomeLossStates = ['VA'];

export const policyLevelAndCopyToCarUMPDStates = ['GA', 'IN', 'MD', 'MS', 'SC', 'TN', 'VA', 'VT', 'WV'];
export const mandatoryPolicyUMPD = { MD: true, VT: true };
export const mandatoryUM = {
  IL: true,
  MA: true,
  MD: true,
  ME: true,
  MO: true,
  ND: true,
  OR: true,
  SD: true,
  VT: true
};
// States exempt from the high-value-home (>$1.25M CovA or RCE) 0.5% minimum-deductible
// floor (GitHub #32676). These states do not permit capping home value as an underwriting
// rule, so the coupled high-value deductible floor must not apply — qualifying high-value
// homes there keep only their standard minimum deductibles. MI is exempt for this reason
// (GitHub #33542); add other states here if they need the same treatment.
export const highValueHomeDeductibleFloorExemptStates = ['MI'];

// Lowest agent-provided replacement cost estimate (a comparative rater's Coverage A, or one entered in Staff)
// that we will rate on.
export const MIN_AGENT_REPLACEMENT_COST = 50000;

// Coverage A may be set anywhere from 100% to this multiple of the replacement cost estimate.
export const MAX_COVERAGE_A_TO_RCE_RATIO = 1.2;

export const isCoverageAWithinRceBand = (coverageA: number, replacementCost: number): boolean =>
  coverageA >= replacementCost && coverageA <= replacementCost * MAX_COVERAGE_A_TO_RCE_RATIO;
